/* tslint:disable */
/* eslint-disable */
/**
 * Campaign Service
 * RMT Campaign API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AllowedBilling
 */
export interface AllowedBilling {
    /**
     * Specifies how advertisers are charged for booking this placement. Once set, cannot be changed. The event types are: * `click` - API Request to generate a click event via GET /track/c?t=... * `add-to-cart` - API Request to generate an add to cart event via GET /track/a?t=... * `CPM` - Thousand impressions, API Request to generate an impression event via GET /track/i.gif?t= 
     * @type {string}
     * @memberof AllowedBilling
     */
    'billing_type': AllowedBillingBillingTypeEnum;
    /**
     * The minimum bid for a campaign in this placement. Can be changed later.
     * @type {number}
     * @memberof AllowedBilling
     */
    'min_bid_in_cents'?: number | null;
    /**
     * Array of category billings. Can be changed later.
     * @type {Array<CategoryBilling>}
     * @memberof AllowedBilling
     */
    'category_billings'?: Array<CategoryBilling> | null;
}

export const AllowedBillingBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type AllowedBillingBillingTypeEnum = typeof AllowedBillingBillingTypeEnum[keyof typeof AllowedBillingBillingTypeEnum];

/**
 * A bill tenancy request.
 * @export
 * @interface BillRequest
 */
export interface BillRequest {
    /**
     * 
     * @type {number}
     * @memberof BillRequest
     */
    'billed_cents': number;
}
/**
 * Defines the parameters for a budget limit. This object includes the budget amount in cents and the reset interval, allowing you to specify a budget limit that reset periodically (e.g., daily, weekly, or monthly). 
 * @export
 * @interface BudgetLimitPut
 */
export interface BudgetLimitPut {
    /**
     * The budget amount in cents. This represents the total amount allocated for the specified interval. For example, if `budget_interval` is `DAILY`, this amount is the daily budget limit. 
     * @type {number}
     * @memberof BudgetLimitPut
     */
    'budget_cents': number;
    /**
     * The interval at which the budget is reset. This defines the reset period for the budget amount, such as daily, weekly, or monthly resets. The budget is reset at the beginning of the specified interval (00:00:00 UTC). 
     * @type {string}
     * @memberof BudgetLimitPut
     */
    'budget_interval': BudgetLimitPutBudgetIntervalEnum;
}

export const BudgetLimitPutBudgetIntervalEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;

export type BudgetLimitPutBudgetIntervalEnum = typeof BudgetLimitPutBudgetIntervalEnum[keyof typeof BudgetLimitPutBudgetIntervalEnum];

/**
 * Defines the parameters for a budget limit. This object includes the budget amount in cents and the reset interval, allowing you to specify a budget limit that reset periodically (e.g., daily, weekly, or monthly). 
 * @export
 * @interface BudgetLimitRequest
 */
export interface BudgetLimitRequest {
    /**
     * The budget amount in cents. This represents the total amount allocated for the specified interval. For example, if `budget_interval` is `DAILY`, this amount is the daily budget limit. 
     * @type {number}
     * @memberof BudgetLimitRequest
     */
    'budget_cents': number;
    /**
     * The interval at which the budget is reset. This defines the reset period for the budget amount, such as daily, weekly, or monthly resets. The budget is reset at the beginning of the specified interval (00:00:00 UTC). 
     * @type {string}
     * @memberof BudgetLimitRequest
     */
    'budget_interval': BudgetLimitRequestBudgetIntervalEnum;
}

export const BudgetLimitRequestBudgetIntervalEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;

export type BudgetLimitRequestBudgetIntervalEnum = typeof BudgetLimitRequestBudgetIntervalEnum[keyof typeof BudgetLimitRequestBudgetIntervalEnum];

/**
 * Defines the parameters for a budget limit. This object includes the budget amount in cents and the reset interval, allowing you to specify a budget limit that reset periodically (e.g., daily, weekly, or monthly). 
 * @export
 * @interface BudgetLimitResponse
 */
export interface BudgetLimitResponse {
    /**
     * The budget amount in cents. This represents the total amount allocated for the specified interval. For example, if `budget_interval` is `DAILY`, this amount is the daily budget limit. 
     * @type {number}
     * @memberof BudgetLimitResponse
     */
    'budget_cents': number;
    /**
     * The interval at which the budget is reset. This defines the reset period for the budget amount, such as daily, weekly, or monthly resets. The budget is reset at the beginning of the specified interval (00:00:00 UTC). 
     * @type {string}
     * @memberof BudgetLimitResponse
     */
    'budget_interval': BudgetLimitResponseBudgetIntervalEnum;
}

export const BudgetLimitResponseBudgetIntervalEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;

export type BudgetLimitResponseBudgetIntervalEnum = typeof BudgetLimitResponseBudgetIntervalEnum[keyof typeof BudgetLimitResponseBudgetIntervalEnum];

/**
 * A structure containing campaign attributes to be updated. Use this to modify specific properties of an existing campaign. 
 * @export
 * @interface CampaignPatch
 */
export interface CampaignPatch {
    /**
     * Unique key that identifies the campaign in the retailer\'s system.
     * @type {string}
     * @memberof CampaignPatch
     */
    'campaign_key'?: string | null;
    /**
     * Key that identifies the advertiser in the retailer\'s system.
     * @type {string}
     * @memberof CampaignPatch
     */
    'advertiser_key'?: string | null;
    /**
     * List of retailer-tags associated with the campaign. This field is only accessible by retailers.
     * @type {Array<string>}
     * @memberof CampaignPatch
     */
    'retailer_tags'?: Array<string> | null;
    /**
     * The updated name of the campaign.
     * @type {string}
     * @memberof CampaignPatch
     */
    'name'?: string | null;
    /**
     * The updated status of the campaign.
     * @type {string}
     * @memberof CampaignPatch
     */
    'status'?: CampaignPatchStatusEnum;
    /**
     * The updated start date of the campaign. The system will trigger it at the beginning of the day (00:00:00), UTC timezone. 
     * @type {string}
     * @memberof CampaignPatch
     */
    'active_from'?: string | null;
    /**
     * The updated end date of the campaign. The system will trigger it at the end of the day (23:59:59), UTC timezone. 
     * @type {string}
     * @memberof CampaignPatch
     */
    'active_to'?: string | null;
    /**
     * The updated total budget of the campaign in cents.
     * @type {number}
     * @memberof CampaignPatch
     */
    'budget_total_cents'?: number | null;
    /**
     * 
     * @type {BudgetLimitRequest}
     * @memberof CampaignPatch
     */
    'budget_limit'?: BudgetLimitRequest | null;
    /**
     * 
     * @type {any}
     * @memberof CampaignPatch
     */
    'custom'?: any;
    /**
     * The updated purchase order number associated with the campaign.
     * @type {string}
     * @memberof CampaignPatch
     */
    'purchase_order_number'?: string | null;
    /**
     * 
     * @type {DigitalServicesActRequest}
     * @memberof CampaignPatch
     */
    'digital_services_act'?: DigitalServicesActRequest | null;
}

export const CampaignPatchStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type CampaignPatchStatusEnum = typeof CampaignPatchStatusEnum[keyof typeof CampaignPatchStatusEnum];

/**
 * Request to create a campaign
 * @export
 * @interface CampaignRequest
 */
export interface CampaignRequest {
    /**
     * ID of the advertiser for whom the campaign is created.
     * @type {string}
     * @memberof CampaignRequest
     */
    'advertiser_id'?: string | null;
    /**
     * Unique key that identifies the campaign in the retailer\'s system.
     * @type {string}
     * @memberof CampaignRequest
     */
    'campaign_key'?: string | null;
    /**
     * Key that identifies the advertiser in the retailer\'s system.
     * @type {string}
     * @memberof CampaignRequest
     */
    'advertiser_key'?: string | null;
    /**
     * List of retailer-tags associated with the campaign. This field is only accessible by retailers.
     * @type {Array<string>}
     * @memberof CampaignRequest
     */
    'retailer_tags'?: Array<string> | null;
    /**
     * The name of the campaign.
     * @type {string}
     * @memberof CampaignRequest
     */
    'name': string;
    /**
     * Campaign start date, the system will trigger it at the beginning of the day (i.e. 00:00:00), UTC timezone
     * @type {string}
     * @memberof CampaignRequest
     */
    'active_from'?: string | null;
    /**
     * Campaign end date, the system will trigger it at the end of the day (i.e. 23:59:59), UTC timezone
     * @type {string}
     * @memberof CampaignRequest
     */
    'active_to'?: string | null;
    /**
     * Total budget for the campaign. Campaign gets stopped when total budget is spent. Depending on billing type this cannot be exact, there will always be some tolerance buffer.
     * @type {number}
     * @memberof CampaignRequest
     */
    'budget_total_cents'?: number | null;
    /**
     * 
     * @type {BudgetLimitRequest}
     * @memberof CampaignRequest
     */
    'budget_limit'?: BudgetLimitRequest | null;
    /**
     * 
     * @type {any}
     * @memberof CampaignRequest
     */
    'custom'?: any;
    /**
     * Purchase order number for the campaign.
     * @type {string}
     * @memberof CampaignRequest
     */
    'purchase_order_number'?: string | null;
    /**
     * 
     * @type {DigitalServicesActRequest}
     * @memberof CampaignRequest
     */
    'digital_services_act'?: DigitalServicesActRequest | null;
}
/**
 * A campaign response
 * @export
 * @interface CampaignResponse
 */
export interface CampaignResponse {
    /**
     * 
     * @type {string}
     * @memberof CampaignResponse
     */
    'id': string;
    /**
     * ID of the advertiser that owns this campaign. Can be used in the filter query string.
     * @type {string}
     * @memberof CampaignResponse
     */
    'advertiser_id': string;
    /**
     * Unique key that identifies the campaign in the retailer\'s system.
     * @type {string}
     * @memberof CampaignResponse
     */
    'campaign_key'?: string | null;
    /**
     * Key that identifies the advertiser in the retailer\'s system.
     * @type {string}
     * @memberof CampaignResponse
     */
    'advertiser_key'?: string | null;
    /**
     * List of retailer-tags associated with the campaign. This field is only accessible by retailers.
     * @type {Array<string>}
     * @memberof CampaignResponse
     */
    'retailer_tags'?: Array<string> | null;
    /**
     * Campaign status. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof CampaignResponse
     */
    'status': CampaignResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignResponse
     */
    'updated_at': string;
    /**
     * Can be used in the filter query string to filter by name. Case insensitive. Use % to search for a substring, e.g. `%promo%` to get both campaigns `Promo 50%` and `October promo`.
     * @type {string}
     * @memberof CampaignResponse
     */
    'name': string;
    /**
     * Campaign start date, the system will trigger it at the beginning of the day (i.e. 00:00:00), UTC timezone. Can be used in the filter query string.
     * @type {string}
     * @memberof CampaignResponse
     */
    'active_from'?: string | null;
    /**
     * Campaign end date, the system will trigger it at the end of the day (i.e. 23:59:59), UTC timezone. Can be used in the filter query string.
     * @type {string}
     * @memberof CampaignResponse
     */
    'active_to'?: string | null;
    /**
     * Campaign total budget. Can be used in the filter query string.
     * @type {number}
     * @memberof CampaignResponse
     */
    'budget_total_cents'?: number | null;
    /**
     * Total budget left in cents
     * @type {number}
     * @memberof CampaignResponse
     */
    'budget_total_left_cents'?: number | null;
    /**
     * Total budget left as percentage of the total budget
     * @type {number}
     * @memberof CampaignResponse
     */
    'budget_total_left_percent'?: number | null;
    /**
     * 
     * @type {BudgetLimitResponse}
     * @memberof CampaignResponse
     */
    'budget_limit'?: BudgetLimitResponse | null;
    /**
     * 
     * @type {any}
     * @memberof CampaignResponse
     */
    'custom'?: any;
    /**
     * 
     * @type {string}
     * @memberof CampaignResponse
     */
    'purchase_order_number'?: string | null;
    /**
     * 
     * @type {DigitalServicesActResponse}
     * @memberof CampaignResponse
     */
    'digital_services_act'?: DigitalServicesActResponse | null;
}

export const CampaignResponseStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type CampaignResponseStatusEnum = typeof CampaignResponseStatusEnum[keyof typeof CampaignResponseStatusEnum];

/**
 * 
 * @export
 * @interface CampaignResponseWrapper
 */
export interface CampaignResponseWrapper {
    /**
     * 
     * @type {CampaignResponse}
     * @memberof CampaignResponseWrapper
     */
    'data'?: CampaignResponse;
}
/**
 * Campaign update request
 * @export
 * @interface CampaignUpdate
 */
export interface CampaignUpdate {
    /**
     * Unique key that identifies the campaign in the retailer\'s system.
     * @type {string}
     * @memberof CampaignUpdate
     */
    'campaign_key': string | null;
    /**
     * Key that identifies the advertiser in the retailer\'s system.
     * @type {string}
     * @memberof CampaignUpdate
     */
    'advertiser_key': string | null;
    /**
     * List of retailer-tags associated with the campaign. This field is only accessible by retailers.
     * @type {Array<string>}
     * @memberof CampaignUpdate
     */
    'retailer_tags'?: Array<string> | null;
    /**
     * Campaign name.
     * @type {string}
     * @memberof CampaignUpdate
     */
    'name': string;
    /**
     * Status of the campaign.
     * @type {string}
     * @memberof CampaignUpdate
     */
    'status': CampaignUpdateStatusEnum;
    /**
     * Campaign start date, the system will trigger it at the beginning of the day (i.e. 00:00:00), UTC timezone
     * @type {string}
     * @memberof CampaignUpdate
     */
    'active_from': string | null;
    /**
     * Campaign end date, the system will trigger it at the end of the day (i.e. 23:59:59), UTC timezone
     * @type {string}
     * @memberof CampaignUpdate
     */
    'active_to': string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignUpdate
     */
    'budget_total_cents': number | null;
    /**
     * 
     * @type {BudgetLimitPut}
     * @memberof CampaignUpdate
     */
    'budget_limit': BudgetLimitPut | null;
    /**
     * 
     * @type {any}
     * @memberof CampaignUpdate
     */
    'custom'?: any;
    /**
     * 
     * @type {string}
     * @memberof CampaignUpdate
     */
    'purchase_order_number': string | null;
    /**
     * 
     * @type {DigitalServicesActUpdate}
     * @memberof CampaignUpdate
     */
    'digital_services_act': DigitalServicesActUpdate | null;
}

export const CampaignUpdateStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type CampaignUpdateStatusEnum = typeof CampaignUpdateStatusEnum[keyof typeof CampaignUpdateStatusEnum];

/**
 * 
 * @export
 * @interface CampaignsResponseWrapper
 */
export interface CampaignsResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof CampaignsResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<CampaignResponse>}
     * @memberof CampaignsResponseWrapper
     */
    'data'?: Array<CampaignResponse>;
}
/**
 * 
 * @export
 * @interface CampaignsRetailerTagsResponseWrapper
 */
export interface CampaignsRetailerTagsResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof CampaignsRetailerTagsResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignsRetailerTagsResponseWrapper
     */
    'data': Array<string>;
}
/**
 * A category of products.
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'category_key': string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    'category_name': string;
}
/**
 * 
 * @export
 * @interface CategoryBilling
 */
export interface CategoryBilling {
    /**
     * 
     * @type {string}
     * @memberof CategoryBilling
     */
    'category_key': string;
    /**
     * The minimum bid for a campaign in this placement, for the category key.
     * @type {number}
     * @memberof CategoryBilling
     */
    'min_bid_in_cents': number;
    /**
     * When set to true, this setting is also applied to all subcategories.
     * @type {boolean}
     * @memberof CategoryBilling
     */
    'inherited'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CreativeProperties
 */
export interface CreativeProperties {
    /**
     * A human readable title for the creative configuration. 
     * @type {string}
     * @memberof CreativeProperties
     */
    'title'?: string;
    /**
     * Specifies the allowed content (MIME) types. If left unspecified, any content type is allowed. 
     * @type {Array<string>}
     * @memberof CreativeProperties
     */
    'content_types'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreativeProperties
     */
    'width': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreativeProperties
     */
    'height': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreativeProperties
     */
    'min_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreativeProperties
     */
    'max_duration'?: number | null;
}
/**
 * Custom placement configuration with all fields available.
 * @export
 * @interface CustomPlacementRequest
 */
export interface CustomPlacementRequest {
    /**
     * The main name for the placement, recognizable by advertisers. Can be changed at any time.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'name': string;
    /**
     * The type of placement that determines which fields are applicable.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'type'?: CustomPlacementRequestTypeEnum;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof CustomPlacementRequest
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * Key of the catalog to which the placement is bound. Once set, cannot be changed.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof CustomPlacementRequest
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * Number of ads returned by the ad service. Can be changed later.
     * @type {number}
     * @memberof CustomPlacementRequest
     */
    'ads_count': number;
    /**
     * Maximum headline length for the placement. If not set, headlines are disabled.
     * @type {number}
     * @memberof CustomPlacementRequest
     */
    'max_headline_length'?: number | null;
    /**
     * Does this placement allow discounts? Cannot be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_discounts': boolean | null;
    /**
     * Does this placement allow keyword filtering? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_keywords': boolean | null;
    /**
     * Does this placement allow audience filtering? Cannot be changed later.  To generate an accurate audience estimate, ensure a `catalog_key` is included in the placement configuration. Additionally, you must submit the `catalog_key` when you track an order. 
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_audience': boolean | null;
    /**
     * Does this placement allow geographic targeting? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_geo': boolean | null;
    /**
     * Does this placement allow dayparting? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_dayparting': boolean | null;
    /**
     * Does this placement allow store filtering? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_stores': boolean | null;
    /**
     * Does this placement allow SKU filtering? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * Does this placement allow external links? Can be changed later.
     * @type {boolean}
     * @memberof CustomPlacementRequest
     */
    'has_link_url': boolean | null;
    /**
     * Important: Please note that the `category_targeting_mode` controls how category-based targeting is configured and applied to placements. Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests.  In addition, `has_categories` field is no longer supported for `POST/PATCH/PUT` operations. However, it will still appear in `GET` responses when it is being returned, `has_categories` will be set to true if `category_targeting_mode` is active/set.  Three targeting modes are available:  **AUTOMATIC_SAME** (Automatic same-category targeting and serving) *  Booking: Advertisers cannot manually select categories. *  Serving: SKUs are automatically served to their respective assigned categories.  **SELECTIVE_SAME** (Manual, selective same-category targeting and serving) *  Booking: Advertisers can manually select categories, but only from categories that match the advertised SKUs. *  Serving: The system only serves SKUs within the selected categories, maintaining SKU-category matching.  **SELECTIVE_ALL** (Manual, all-category targeting and serving) *  Booking: Advertisers can manually select from any categories available in the placement\'s catalog. *  Serving: Ads are served to the selected target categories without enforcing SKU-to-category matching. 
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'category_targeting_mode'?: CustomPlacementRequestCategoryTargetingModeEnum;
    /**
     * 
     * @type {PlacementCreatives}
     * @memberof CustomPlacementRequest
     */
    'creatives'?: PlacementCreatives | null;
    /**
     * Main placement description for advertisers to understand and book. Can be changed any time.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'description'?: string | null;
    /**
     * Visual placement preview for advertisers to recognize and book. Can be changed any time.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'image_url'?: string | null;
    /**
     * Bid weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof CustomPlacementRequest
     */
    'weight_bid'?: number | null;
    /**
     * Relevance weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof CustomPlacementRequest
     */
    'weight_relevance'?: number | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof CustomPlacementRequest
     */
    'group'?: string | null;
    /**
     * 
     * @type {PlacementsAttributionRequest}
     * @memberof CustomPlacementRequest
     */
    'attribution'?: PlacementsAttributionRequest | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof CustomPlacementRequest
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof CustomPlacementRequest
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof CustomPlacementRequest
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof CustomPlacementRequest
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PreviewTemplates; }}
     * @memberof CustomPlacementRequest
     */
    'preview_templates'?: { [key: string]: PreviewTemplates; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof CustomPlacementRequest
     */
    'requires_approval'?: Array<CustomPlacementRequestRequiresApprovalEnum>;
}

export const CustomPlacementRequestTypeEnum = {
    Custom: 'CUSTOM'
} as const;

export type CustomPlacementRequestTypeEnum = typeof CustomPlacementRequestTypeEnum[keyof typeof CustomPlacementRequestTypeEnum];
export const CustomPlacementRequestCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type CustomPlacementRequestCategoryTargetingModeEnum = typeof CustomPlacementRequestCategoryTargetingModeEnum[keyof typeof CustomPlacementRequestCategoryTargetingModeEnum];
export const CustomPlacementRequestRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type CustomPlacementRequestRequiresApprovalEnum = typeof CustomPlacementRequestRequiresApprovalEnum[keyof typeof CustomPlacementRequestRequiresApprovalEnum];

/**
 * Digital Out of Home placement configuration.
 * @export
 * @interface DOOHPlacementRequest
 */
export interface DOOHPlacementRequest {
    /**
     * The main name for the placement, recognizable by advertisers. Can be changed at any time.
     * @type {string}
     * @memberof DOOHPlacementRequest
     */
    'name': string;
    /**
     * The type of placement that determines which fields are applicable.
     * @type {string}
     * @memberof DOOHPlacementRequest
     */
    'type'?: DOOHPlacementRequestTypeEnum;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof DOOHPlacementRequest
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof DOOHPlacementRequest
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * Number of ads returned by the ad service. Can be changed later.
     * @type {number}
     * @memberof DOOHPlacementRequest
     */
    'ads_count': number;
    /**
     * Does this placement allow geographic targeting? Can be changed later.
     * @type {boolean}
     * @memberof DOOHPlacementRequest
     */
    'has_geo': boolean | null;
    /**
     * Does this placement allow dayparting? Can be changed later.
     * @type {boolean}
     * @memberof DOOHPlacementRequest
     */
    'has_dayparting': boolean | null;
    /**
     * 
     * @type {PlacementCreatives}
     * @memberof DOOHPlacementRequest
     */
    'creatives'?: PlacementCreatives | null;
    /**
     * Main placement description for advertisers to understand and book. Can be changed any time.
     * @type {string}
     * @memberof DOOHPlacementRequest
     */
    'description'?: string | null;
    /**
     * Visual placement preview for advertisers to recognize and book. Can be changed any time.
     * @type {string}
     * @memberof DOOHPlacementRequest
     */
    'image_url'?: string | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof DOOHPlacementRequest
     */
    'group'?: string | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof DOOHPlacementRequest
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof DOOHPlacementRequest
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof DOOHPlacementRequest
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof DOOHPlacementRequest
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof DOOHPlacementRequest
     */
    'requires_approval'?: Array<DOOHPlacementRequestRequiresApprovalEnum>;
}

export const DOOHPlacementRequestTypeEnum = {
    Dooh: 'DOOH'
} as const;

export type DOOHPlacementRequestTypeEnum = typeof DOOHPlacementRequestTypeEnum[keyof typeof DOOHPlacementRequestTypeEnum];
export const DOOHPlacementRequestRequiresApprovalEnum = {
    Creatives: 'creatives',
    CustomTargeting: 'custom_targeting',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type DOOHPlacementRequestRequiresApprovalEnum = typeof DOOHPlacementRequestRequiresApprovalEnum[keyof typeof DOOHPlacementRequestRequiresApprovalEnum];

/**
 * `DATES` commitment delivers the line item for the full duration of the campaign (from `start_date` to `end_date`). 
 * @export
 * @interface DatesCommitment
 */
export interface DatesCommitment {
    /**
     * 
     * @type {string}
     * @memberof DatesCommitment
     */
    'type': DatesCommitmentTypeEnum;
    /**
     * Position in the ad set.
     * @type {number}
     * @memberof DatesCommitment
     */
    'position'?: number;
    /**
     * The date on which the line item\'s total budget should be billed.
     * @type {string}
     * @memberof DatesCommitment
     */
    'bill_total_at': string;
}

export const DatesCommitmentTypeEnum = {
    Dates: 'DATES'
} as const;

export type DatesCommitmentTypeEnum = typeof DatesCommitmentTypeEnum[keyof typeof DatesCommitmentTypeEnum];

/**
 * DSA Ad Transparency information.
 * @export
 * @interface DigitalServicesActRequest
 */
export interface DigitalServicesActRequest {
    /**
     * Name of the entity on whose behalf the ad is being served.
     * @type {string}
     * @memberof DigitalServicesActRequest
     */
    'behalf': string;
    /**
     * Name of the entity that has paid for the ad to be served.
     * @type {string}
     * @memberof DigitalServicesActRequest
     */
    'paid': string;
}
/**
 * DSA Ad Transparency information.
 * @export
 * @interface DigitalServicesActResponse
 */
export interface DigitalServicesActResponse {
    /**
     * Name of the entity on whose behalf the ad is being served.
     * @type {string}
     * @memberof DigitalServicesActResponse
     */
    'behalf': string;
    /**
     * Name of the entity that has paid for the ad to be served.
     * @type {string}
     * @memberof DigitalServicesActResponse
     */
    'paid': string;
}
/**
 * DSA Ad Transparency information.
 * @export
 * @interface DigitalServicesActUpdate
 */
export interface DigitalServicesActUpdate {
    /**
     * Name of the entity on whose behalf the ad is being served.
     * @type {string}
     * @memberof DigitalServicesActUpdate
     */
    'behalf': string;
    /**
     * Name of the entity that has paid for the ad to be served.
     * @type {string}
     * @memberof DigitalServicesActUpdate
     */
    'paid': string;
}
/**
 * Display advertising placement configuration.
 * @export
 * @interface DisplayPlacementRequest
 */
export interface DisplayPlacementRequest {
    /**
     * The main name for the placement, recognizable by advertisers. Can be changed at any time.
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'type'?: DisplayPlacementRequestTypeEnum;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof DisplayPlacementRequest
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * Key of the catalog to which the placement is bound. Once set, cannot be changed.
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof DisplayPlacementRequest
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * Number of ads returned by the ad service. Can be changed later.
     * @type {number}
     * @memberof DisplayPlacementRequest
     */
    'ads_count': number;
    /**
     * Maximum headline length for the placement. If not set, headlines are disabled.
     * @type {number}
     * @memberof DisplayPlacementRequest
     */
    'max_headline_length'?: number | null;
    /**
     * Deprecated. Use the `creatives` configuration instead.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     * @deprecated
     */
    'has_creatives'?: boolean | null;
    /**
     * Does this placement allow discounts? Cannot be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_discounts': boolean | null;
    /**
     * Does this placement allow audience filtering? Cannot be changed later.  To generate an accurate audience estimate, ensure a `catalog_key` is included in the placement configuration. Additionally, you must submit the `catalog_key` when you track an order. 
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_audience': boolean | null;
    /**
     * Does this placement allow geographic targeting? Can be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_geo': boolean | null;
    /**
     * Does this placement allow dayparting? Can be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_dayparting': boolean | null;
    /**
     * Deprecated. Use `category_targeting_mode` instead.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     * @deprecated
     */
    'has_categories'?: boolean | null;
    /**
     * Does this placement allow store filtering? Can be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_stores': boolean | null;
    /**
     * Does this placement allow SKU filtering? Can be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * Does this placement allow external links? Can be changed later.
     * @type {boolean}
     * @memberof DisplayPlacementRequest
     */
    'has_link_url': boolean | null;
    /**
     * Important: Please note that the `category_targeting_mode` controls how category-based targeting is configured and applied to placements. Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests.  In addition, `has_categories` field is no longer supported for `POST/PATCH/PUT` operations. However, it will still appear in `GET` responses when it is being returned, `has_categories` will be set to true if `category_targeting_mode` is active/set.  Three targeting modes are available:  **AUTOMATIC_SAME** (Automatic same-category targeting and serving) *  Booking: Advertisers cannot manually select categories. *  Serving: SKUs are automatically served to their respective assigned categories.  **SELECTIVE_SAME** (Manual, selective same-category targeting and serving) *  Booking: Advertisers can manually select categories, but only from categories that match the advertised SKUs. *  Serving: The system only serves SKUs within the selected categories, maintaining SKU-category matching.  **SELECTIVE_ALL** (Manual, all-category targeting and serving) *  Booking: Advertisers can manually select from any categories available in the placement\'s catalog. *  Serving: Ads are served to the selected target categories without enforcing SKU-to-category matching. 
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'category_targeting_mode'?: DisplayPlacementRequestCategoryTargetingModeEnum;
    /**
     * 
     * @type {PlacementCreatives}
     * @memberof DisplayPlacementRequest
     */
    'creatives'?: PlacementCreatives | null;
    /**
     * Main placement description for advertisers to understand and book. Can be changed any time.
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'description'?: string | null;
    /**
     * Visual placement preview for advertisers to recognize and book. Can be changed any time.
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'image_url'?: string | null;
    /**
     * Bid weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof DisplayPlacementRequest
     */
    'weight_bid'?: number | null;
    /**
     * Relevance weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof DisplayPlacementRequest
     */
    'weight_relevance'?: number | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof DisplayPlacementRequest
     */
    'group'?: string | null;
    /**
     * 
     * @type {PlacementsAttributionRequest}
     * @memberof DisplayPlacementRequest
     */
    'attribution'?: PlacementsAttributionRequest | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof DisplayPlacementRequest
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof DisplayPlacementRequest
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof DisplayPlacementRequest
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof DisplayPlacementRequest
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PreviewTemplates; }}
     * @memberof DisplayPlacementRequest
     */
    'preview_templates'?: { [key: string]: PreviewTemplates; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof DisplayPlacementRequest
     */
    'requires_approval'?: Array<DisplayPlacementRequestRequiresApprovalEnum>;
}

export const DisplayPlacementRequestTypeEnum = {
    Display: 'DISPLAY'
} as const;

export type DisplayPlacementRequestTypeEnum = typeof DisplayPlacementRequestTypeEnum[keyof typeof DisplayPlacementRequestTypeEnum];
export const DisplayPlacementRequestCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type DisplayPlacementRequestCategoryTargetingModeEnum = typeof DisplayPlacementRequestCategoryTargetingModeEnum[keyof typeof DisplayPlacementRequestCategoryTargetingModeEnum];
export const DisplayPlacementRequestRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type DisplayPlacementRequestRequiresApprovalEnum = typeof DisplayPlacementRequestRequiresApprovalEnum[keyof typeof DisplayPlacementRequestRequiresApprovalEnum];

/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'code': ErrorResponseCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'status': ErrorResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'request_id': string;
}

export const ErrorResponseCodeEnum = {
    NUMBER_400: 400,
    NUMBER_401: 401,
    NUMBER_404: 404,
    NUMBER_409: 409,
    NUMBER_422: 422,
    NUMBER_500: 500,
    NUMBER_503: 503
} as const;

export type ErrorResponseCodeEnum = typeof ErrorResponseCodeEnum[keyof typeof ErrorResponseCodeEnum];
export const ErrorResponseStatusEnum = {
    Error: 'error'
} as const;

export type ErrorResponseStatusEnum = typeof ErrorResponseStatusEnum[keyof typeof ErrorResponseStatusEnum];

/**
 * Configuration for limiting how often an individual shopper is exposed to a specific line item. This object defines a frequency cap policy by specifying a rolling time window and a maximum number of impressions per shopper. 
 * @export
 * @interface FrequencyCapConfig
 */
export interface FrequencyCapConfig {
    /**
     * The unit of time used to define the frequency cap window.  Currently, only `DAY` is supported, meaning the cap is calculated over a number of consecutive calendar days.  For example, if `period_unit` is `DAY` and `period_count` is `7`, the cap applies to a 7-day rolling window. 
     * @type {string}
     * @memberof FrequencyCapConfig
     */
    'period_unit': FrequencyCapConfigPeriodUnitEnum;
    /**
     * The number of time units (as defined by `period_unit`) over which the frequency cap is applied.  Supported values: - If `period_unit` is `DAY`, valid values are from 1 to 30.  For example: - `period_unit: DAY` and `period_count: 7` means the cap is calculated over a 7-day rolling period. 
     * @type {number}
     * @memberof FrequencyCapConfig
     */
    'period_count': number;
    /**
     * The maximum number of times a shopper is allowed to view the line item within the defined period.  This limit applies on a per-shopper basis.  For example: - `max_impressions: 3` with a 7-day period means each shopper can see the ad up to 3 times every rolling 7-day window. 
     * @type {number}
     * @memberof FrequencyCapConfig
     */
    'max_impressions': number;
}

export const FrequencyCapConfigPeriodUnitEnum = {
    Day: 'DAY'
} as const;

export type FrequencyCapConfigPeriodUnitEnum = typeof FrequencyCapConfigPeriodUnitEnum[keyof typeof FrequencyCapConfigPeriodUnitEnum];

/**
 * Geographic targeting for line items using latitude, longitude, and radius. Used to filter line items based on their configured geo-fence. 
 * @export
 * @interface GeoTargeting
 */
export interface GeoTargeting {
    /**
     * Latitude of the geo-targeting center point.
     * @type {number}
     * @memberof GeoTargeting
     */
    'lat': number;
    /**
     * Longitude of the geo-targeting center point.
     * @type {number}
     * @memberof GeoTargeting
     */
    'lon': number;
    /**
     * Radius in kilometers from the center point. Minimum 1km, maximum 100km.
     * @type {number}
     * @memberof GeoTargeting
     */
    'radius': number;
}
/**
 * A structure containing line item attributes to be updated. Use this to modify specific properties of an existing line item. 
 * @export
 * @interface LineItemAttributesPatch
 */
export interface LineItemAttributesPatch {
    /**
     * The updated name of the line item.
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'name'?: string | null;
    /**
     * The updated status of the line item from the advertiser\'s perspective.
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'advertiser_status'?: LineItemAttributesPatchAdvertiserStatusEnum;
    /**
     * SKUs to be advertised in the updated line item.
     * @type {Array<string>}
     * @memberof LineItemAttributesPatch
     */
    'advertised_skus'?: Array<string>;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemAttributesPatch
     */
    'target_category_keys'?: Array<string>;
    /**
     * Keywords describing the updated line item.
     * @type {Array<string>}
     * @memberof LineItemAttributesPatch
     */
    'keywords'?: Array<string>;
    /**
     * Specifies the ad delivery method for the line item. Ads are served either through an auction-based ranking (AUCTION) or via guaranteed delivery (GUARANTEED). House ads (HOUSE_AD) can be used to fill ad slots when no other ads are available. Advertisers cannot change this field. 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'delivery_mode'?: LineItemAttributesPatchDeliveryModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'billing_type'?: LineItemAttributesPatchBillingTypeEnum;
    /**
     * 
     * @type {LineItemRequestCommitment}
     * @memberof LineItemAttributesPatch
     */
    'commitment'?: LineItemRequestCommitment | null;
    /**
     * The updated total budget of the line item in cents.
     * @type {number}
     * @memberof LineItemAttributesPatch
     */
    'budget_total_cents'?: number | null;
    /**
     * 
     * @type {BudgetLimitRequest}
     * @memberof LineItemAttributesPatch
     */
    'budget_limit'?: BudgetLimitRequest | null;
    /**
     * The updated monetary bid that the advertiser wants to pay, based on the billing type of the placement. 
     * @type {number}
     * @memberof LineItemAttributesPatch
     */
    'bid_cents'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemAttributesPatch
     */
    'custom'?: any;
    /**
     * 
     * @type {Array<FrequencyCapConfig>}
     * @memberof LineItemAttributesPatch
     */
    'frequency_cap_configs'?: Array<FrequencyCapConfig> | null;
    /**
     * The updated UUID reference to the audience. NULL means no audience restriction, targeting everyone. 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'audience_id'?: string | null;
    /**
     * The updated UUID reference to the tenancy filter. NULL means the line item is not assigned to a tenancy filter, participating in the auctioning process. 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'tenancy_filter_id'?: string | null;
    /**
     * The updated headline text at a native ad placement.
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'headline'?: string | null;
    /**
     * Creatives URLs for a line item. The labels in the mapping need to match the object name created in the placement creatives configuration. Please ensure to only reference URLs to ad assets that adhere to the defined width and height in the placement, and conform to common ad standards in sizing (see [IAB](https://iabtechlab.com/standards/iab-new-ad-portfolio-guidelines/)). 
     * @type {{ [key: string]: LineItemCreativesValue; }}
     * @memberof LineItemAttributesPatch
     */
    'creatives'?: { [key: string]: LineItemCreativesValue; } | null;
    /**
     * The updated URL for a potential external link (if allowed by the retailer). 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'link_url'?: string | null;
    /**
     * The budget spending pacing determines how the line item\'s allocated budget is distributed over the duration of the campaign start and end date. `EVEN` Pacing: Ensures a balanced distribution of budget throughout the campaign. `ASAP` Pacing: Prioritizes spending the allocated budget as quickly as possible. This means that the budget may be exhausted well before the campaign end date. Use this option when immediate visibility and maximum exposure are primary goals. 
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'pacing_type'?: LineItemAttributesPatchPacingTypeEnum;
    /**
     * The updated discount that applies to products in the line item. Can be monetary or percentual. 
     * @type {number}
     * @memberof LineItemAttributesPatch
     */
    'discount_value'?: number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemAttributesPatch
     */
    'discount_type'?: LineItemAttributesPatchDiscountTypeEnum;
    /**
     * Define the additional targeting criteria for a line item to be returned. The configuration is a map of targeting keys to their boolean expressions. The targeting keys must match the regex `^[a-z0-9_]+$`, allowing only lowercase alphanumeric characters and underscores. Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: LineItemsCustomTargetingValue; }}
     * @memberof LineItemAttributesPatch
     */
    'custom_targeting'?: { [key: string]: LineItemsCustomTargetingValue; } | null;
    /**
     * A JSON object bound to the rules of the Custom Template of the placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof LineItemAttributesPatch
     */
    'custom_parameters'?: any;
    /**
     * 
     * @type {LineItemGoalRequest}
     * @memberof LineItemAttributesPatch
     */
    'goal'?: LineItemGoalRequest | null;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemAttributesPatch
     */
    'geo_targets'?: Array<GeoTargeting> | null;
    /**
     * 
     * @type {ScheduleRequest}
     * @memberof LineItemAttributesPatch
     */
    'schedule'?: ScheduleRequest | null;
}

export const LineItemAttributesPatchAdvertiserStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type LineItemAttributesPatchAdvertiserStatusEnum = typeof LineItemAttributesPatchAdvertiserStatusEnum[keyof typeof LineItemAttributesPatchAdvertiserStatusEnum];
export const LineItemAttributesPatchDeliveryModeEnum = {
    Auction: 'AUCTION',
    Guaranteed: 'GUARANTEED',
    HouseAd: 'HOUSE_AD'
} as const;

export type LineItemAttributesPatchDeliveryModeEnum = typeof LineItemAttributesPatchDeliveryModeEnum[keyof typeof LineItemAttributesPatchDeliveryModeEnum];
export const LineItemAttributesPatchBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type LineItemAttributesPatchBillingTypeEnum = typeof LineItemAttributesPatchBillingTypeEnum[keyof typeof LineItemAttributesPatchBillingTypeEnum];
export const LineItemAttributesPatchPacingTypeEnum = {
    Asap: 'ASAP',
    Even: 'EVEN'
} as const;

export type LineItemAttributesPatchPacingTypeEnum = typeof LineItemAttributesPatchPacingTypeEnum[keyof typeof LineItemAttributesPatchPacingTypeEnum];
export const LineItemAttributesPatchDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemAttributesPatchDiscountTypeEnum = typeof LineItemAttributesPatchDiscountTypeEnum[keyof typeof LineItemAttributesPatchDiscountTypeEnum];

/**
 * @type LineItemCommitment
 * Mandatory for `GUARANTEED` delivery mode; not allowed for others. Indicates the delivery commitment for the line item and is configurable exclusively by the retailer. The line item total budget must be provided and the bid must not be set; otherwise, the request will fail validation. 
 * @export
 */
export type LineItemCommitment = { type: 'DATES' } & DatesCommitment | { type: 'VOLUME' } & VolumeCommitment;

/**
 * Creative entry containing the banner ad creative URL and an optional duration. 
 * @export
 * @interface LineItemCreativesValue
 */
export interface LineItemCreativesValue {
    /**
     * 
     * @type {string}
     * @memberof LineItemCreativesValue
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof LineItemCreativesValue
     */
    'duration'?: number;
}
/**
 * Defines the goal for a line item
 * @export
 * @interface LineItemGoalRequest
 */
export interface LineItemGoalRequest {
    /**
     * 
     * @type {string}
     * @memberof LineItemGoalRequest
     */
    'type': LineItemGoalRequestTypeEnum;
    /**
     * Required only when type is \'roas\'. Should be omitted for other types.
     * @type {number}
     * @memberof LineItemGoalRequest
     */
    'target'?: number | null;
    /**
     * The minimum bid amount in cents. It cannot be lower than the placement\'s minimum bid or the line item bid.
     * @type {number}
     * @memberof LineItemGoalRequest
     */
    'min_bid_cents': number;
}

export const LineItemGoalRequestTypeEnum = {
    Clicks: 'clicks',
    Roas: 'roas',
    Conversion: 'conversion'
} as const;

export type LineItemGoalRequestTypeEnum = typeof LineItemGoalRequestTypeEnum[keyof typeof LineItemGoalRequestTypeEnum];

/**
 * Defines the goal for a line item
 * @export
 * @interface LineItemGoalResponse
 */
export interface LineItemGoalResponse {
    /**
     * 
     * @type {string}
     * @memberof LineItemGoalResponse
     */
    'type': LineItemGoalResponseTypeEnum;
    /**
     * Required only when type is \'roas\'. Should be omitted for other types.
     * @type {number}
     * @memberof LineItemGoalResponse
     */
    'target'?: number | null;
    /**
     * The minimum bid amount in cents. It cannot be lower than the placement\'s minimum bid or the line item bid.
     * @type {number}
     * @memberof LineItemGoalResponse
     */
    'min_bid_cents': number;
}

export const LineItemGoalResponseTypeEnum = {
    Clicks: 'clicks',
    Roas: 'roas',
    Conversion: 'conversion'
} as const;

export type LineItemGoalResponseTypeEnum = typeof LineItemGoalResponseTypeEnum[keyof typeof LineItemGoalResponseTypeEnum];

/**
 * Defines the goal for a line item
 * @export
 * @interface LineItemGoalUpdate
 */
export interface LineItemGoalUpdate {
    /**
     * 
     * @type {string}
     * @memberof LineItemGoalUpdate
     */
    'type': LineItemGoalUpdateTypeEnum;
    /**
     * Required only when type is \'roas\'. Should be omitted for other types.
     * @type {number}
     * @memberof LineItemGoalUpdate
     */
    'target'?: number | null;
    /**
     * The minimum bid amount in cents. It cannot be lower than the placement\'s minimum bid or the line item bid.
     * @type {number}
     * @memberof LineItemGoalUpdate
     */
    'min_bid_cents': number;
}

export const LineItemGoalUpdateTypeEnum = {
    Clicks: 'clicks',
    Roas: 'roas',
    Conversion: 'conversion'
} as const;

export type LineItemGoalUpdateTypeEnum = typeof LineItemGoalUpdateTypeEnum[keyof typeof LineItemGoalUpdateTypeEnum];

/**
 * An line item response
 * @export
 * @interface LineItemListResponse
 */
export interface LineItemListResponse {
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'id': string;
    /**
     * ID of the placement this line item bids for. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'placement_id': string;
    /**
     * ID of the campaign this line item is part of. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'campaign_id': string;
    /**
     * Status defined by the retailer. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'retailer_status': LineItemListResponseRetailerStatusEnum;
    /**
     * Approval status of the line item pending changes.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'retailer_approval': LineItemListResponseRetailerApprovalEnum;
    /**
     * Status defined by the advertiser. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'advertiser_status': LineItemListResponseAdvertiserStatusEnum;
    /**
     * 
     * @type {Serving}
     * @memberof LineItemListResponse
     */
    'serving': Serving;
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'approved_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'updated_at': string;
    /**
     * Can be used in the filter query string to filter by name. Case insensitive. Use % to search for a substring, e.g. `%promo%` to get both line items `Promo 50%` and `October promo`.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'name': string;
    /**
     * SKUs advertised by this line item. Can be used in the filter query string.
     * @type {Array<string>}
     * @memberof LineItemListResponse
     */
    'advertised_skus'?: Array<string>;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemListResponse
     */
    'target_category_keys'?: Array<string>;
    /**
     * Keywords describing this line item.
     * @type {Array<string>}
     * @memberof LineItemListResponse
     */
    'keywords'?: Array<string>;
    /**
     * Specifies the ad delivery method for the line item. Ads are served either through an auction-based ranking (AUCTION) or via guaranteed delivery (GUARANTEED). House ads (HOUSE_AD) might be served when no other ads are available. Can be used in the filter query string. 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'delivery_mode'?: LineItemListResponseDeliveryModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LineItemListResponse
     */
    'billing_type'?: LineItemListResponseBillingTypeEnum;
    /**
     * 
     * @type {LineItemRequestCommitment}
     * @memberof LineItemListResponse
     */
    'commitment'?: LineItemRequestCommitment | null;
    /**
     * Line item total budget. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemListResponse
     */
    'budget_total_cents'?: number | null;
    /**
     * Total budget left in cents. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemListResponse
     */
    'budget_total_left_cents'?: number | null;
    /**
     * Total budget left as percentage of the total budget. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemListResponse
     */
    'budget_total_left_percent'?: number | null;
    /**
     * 
     * @type {BudgetLimitResponse}
     * @memberof LineItemListResponse
     */
    'budget_limit'?: BudgetLimitResponse | null;
    /**
     * Monetary bid that the advertiser wants to pay based on the billing type of the particular placement. Each billing event generated by the tracking service is billed with the currently valid bid (i.e. added to the spent budget of the line item). Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemListResponse
     */
    'bid_cents'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemListResponse
     */
    'custom'?: any;
    /**
     * 
     * @type {Array<FrequencyCapConfig>}
     * @memberof LineItemListResponse
     */
    'frequency_cap_configs'?: Array<FrequencyCapConfig>;
    /**
     * Uuid reference to the audience. NULL means no audience restriction, hence to target everyone.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'audience_id'?: string | null;
    /**
     * Uuid reference to the tenancy filter. NULL means line item is not assigned to a tenancy filter, hence it takes part in the auctioning process. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'tenancy_filter_id'?: string | null;
    /**
     * Message from the retailer.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'retailer_message'?: string | null;
    /**
     * Headline text at a native ad placement.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'headline'?: string | null;
    /**
     * Creatives URLs for a line item. The labels in the mapping need to match the object name created in the placement creatives configuration. Please ensure to only reference URLs to ad assets that adhere to the defined width and height in the placement, and conform to common ad standards in sizing (see [IAB](https://iabtechlab.com/standards/iab-new-ad-portfolio-guidelines/)). 
     * @type {{ [key: string]: LineItemCreativesValue; }}
     * @memberof LineItemListResponse
     */
    'creatives'?: { [key: string]: LineItemCreativesValue; } | null;
    /**
     * For a potential external link (if allowed by the retailer).
     * @type {string}
     * @memberof LineItemListResponse
     */
    'link_url'?: string | null;
    /**
     * Type of pacing of the line item.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'pacing_type': LineItemListResponsePacingTypeEnum;
    /**
     * Discount that applies to products in the line item. Can be monetary or percentual.
     * @type {number}
     * @memberof LineItemListResponse
     */
    'discount_value'?: number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemListResponse
     */
    'discount_type'?: LineItemListResponseDiscountTypeEnum;
    /**
     * Define the additional targeting criteria for a line item to be returned. The configuration is a map of targeting keys to their boolean expressions. The targeting keys must match the regex `^[a-z0-9_]+$`, allowing only lowercase alphanumeric characters and underscores. Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: LineItemsCustomTargetingValue; }}
     * @memberof LineItemListResponse
     */
    'custom_targeting'?: { [key: string]: LineItemsCustomTargetingValue; } | null;
    /**
     * 
     * @type {LineItemPendingChangesResponse}
     * @memberof LineItemListResponse
     */
    'pending_changes'?: LineItemPendingChangesResponse | null;
    /**
     * 
     * @type {LineItemGoalResponse}
     * @memberof LineItemListResponse
     */
    'goal'?: LineItemGoalResponse | null;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemListResponse
     */
    'geo_targets'?: Array<GeoTargeting> | null;
}

export const LineItemListResponseRetailerStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type LineItemListResponseRetailerStatusEnum = typeof LineItemListResponseRetailerStatusEnum[keyof typeof LineItemListResponseRetailerStatusEnum];
export const LineItemListResponseRetailerApprovalEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type LineItemListResponseRetailerApprovalEnum = typeof LineItemListResponseRetailerApprovalEnum[keyof typeof LineItemListResponseRetailerApprovalEnum];
export const LineItemListResponseAdvertiserStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type LineItemListResponseAdvertiserStatusEnum = typeof LineItemListResponseAdvertiserStatusEnum[keyof typeof LineItemListResponseAdvertiserStatusEnum];
export const LineItemListResponseDeliveryModeEnum = {
    Auction: 'AUCTION',
    Guaranteed: 'GUARANTEED',
    HouseAd: 'HOUSE_AD'
} as const;

export type LineItemListResponseDeliveryModeEnum = typeof LineItemListResponseDeliveryModeEnum[keyof typeof LineItemListResponseDeliveryModeEnum];
export const LineItemListResponseBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type LineItemListResponseBillingTypeEnum = typeof LineItemListResponseBillingTypeEnum[keyof typeof LineItemListResponseBillingTypeEnum];
export const LineItemListResponsePacingTypeEnum = {
    Asap: 'ASAP',
    Even: 'EVEN'
} as const;

export type LineItemListResponsePacingTypeEnum = typeof LineItemListResponsePacingTypeEnum[keyof typeof LineItemListResponsePacingTypeEnum];
export const LineItemListResponseDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemListResponseDiscountTypeEnum = typeof LineItemListResponseDiscountTypeEnum[keyof typeof LineItemListResponseDiscountTypeEnum];

/**
 * @type LineItemPatch
 * An line item patch union, supporting two types of patching
 * @export
 */
export type LineItemPatch = LineItemAttributesPatch | LineItemRetailerStatusPatch;

/**
 * A response containing details about pending changes to a line item. Use this to retrieve information about pending changes to an existing line item. 
 * @export
 * @interface LineItemPendingChangesResponse
 */
export interface LineItemPendingChangesResponse {
    /**
     * SKUs advertised by the line item.
     * @type {Array<string>}
     * @memberof LineItemPendingChangesResponse
     */
    'advertised_skus'?: Array<string> | null;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemPendingChangesResponse
     */
    'target_category_keys'?: Array<string> | null;
    /**
     * Keywords describing the line item.
     * @type {Array<string>}
     * @memberof LineItemPendingChangesResponse
     */
    'keywords'?: Array<string> | null;
    /**
     * Headline text at a native ad placement.
     * @type {string}
     * @memberof LineItemPendingChangesResponse
     */
    'headline'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemPendingChangesResponse
     */
    'creatives'?: any;
    /**
     * For a potential external link (if allowed by the retailer).
     * @type {string}
     * @memberof LineItemPendingChangesResponse
     */
    'link_url'?: string | null;
    /**
     * Uuid reference to the audience.
     * @type {string}
     * @memberof LineItemPendingChangesResponse
     */
    'audience_id'?: string | null;
    /**
     * Discount that applies to products in the line item.
     * @type {number}
     * @memberof LineItemPendingChangesResponse
     */
    'discount_value'?: number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemPendingChangesResponse
     */
    'discount_type'?: LineItemPendingChangesResponseDiscountTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof LineItemPendingChangesResponse
     */
    'custom_targeting'?: any;
    /**
     * A JSON object bound to the rules of the Custom Template of the placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof LineItemPendingChangesResponse
     */
    'custom_parameters'?: any;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemPendingChangesResponse
     */
    'geo_targets'?: Array<GeoTargeting> | null;
    /**
     * 
     * @type {ScheduleResponse}
     * @memberof LineItemPendingChangesResponse
     */
    'schedule'?: ScheduleResponse | null;
}

export const LineItemPendingChangesResponseDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemPendingChangesResponseDiscountTypeEnum = typeof LineItemPendingChangesResponseDiscountTypeEnum[keyof typeof LineItemPendingChangesResponseDiscountTypeEnum];

/**
 * Request to create an line item
 * @export
 * @interface LineItemRequest
 */
export interface LineItemRequest {
    /**
     * ID of the placement for which the line item is created.
     * @type {string}
     * @memberof LineItemRequest
     */
    'placement_id': string;
    /**
     * ID of the campaign for which the line item is created.
     * @type {string}
     * @memberof LineItemRequest
     */
    'campaign_id': string;
    /**
     * The name of the line item.
     * @type {string}
     * @memberof LineItemRequest
     */
    'name': string;
    /**
     * SKUs advertised by the line item.
     * @type {Array<string>}
     * @memberof LineItemRequest
     */
    'advertised_skus'?: Array<string>;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemRequest
     */
    'target_category_keys'?: Array<string>;
    /**
     * Keywords to target or exclude for the line item. * Broad match: Use `keyword` (e.g., `pasta` will also target `pasta sauce`). * Exact match: Use `[keyword]` (e.g., `[pasta]` will only target `pasta` exactly and not target `pasta sauce`). * Negative keywords: Use `-keyword` (e.g., `-pasta` will exclude any targeting of `pasta sauce` for a broad match, and [`-pasta sauce`] will exlude any targeting for an exact match like `pasta sauce`. A maximum of 100 keywords, including both positive and negative keywords, can be set. 
     * @type {Array<string>}
     * @memberof LineItemRequest
     */
    'keywords'?: Array<string>;
    /**
     * Specifies the ad delivery method for the line item. Ads are served either through an auction-based ranking (AUCTION) or via guaranteed delivery (GUARANTEED). House ads (HOUSE_AD) can be used to fill ad slots when no other ads are available. Advertisers may only specify AUCTION or omit the field entirely. 
     * @type {string}
     * @memberof LineItemRequest
     */
    'delivery_mode'?: LineItemRequestDeliveryModeEnum;
    /**
     * The billing types are: * `CPM` - Thousand impressions, API Request to generate an impression event via GET /track/i.gif?t= * `click` - API Request to generate a click event via GET /track/c?t=... * `add-to-cart` - API Request to generate an add to cart event via GET /track/a?t=... 
     * @type {string}
     * @memberof LineItemRequest
     */
    'billing_type'?: LineItemRequestBillingTypeEnum;
    /**
     * 
     * @type {LineItemRequestCommitment}
     * @memberof LineItemRequest
     */
    'commitment'?: LineItemRequestCommitment | null;
    /**
     * Total budget for the line item. Line Item gets stopped when total budget is spent. Depending on billing type this cannot be exact, there will always be some tolerance buffer.
     * @type {number}
     * @memberof LineItemRequest
     */
    'budget_total_cents'?: number | null;
    /**
     * 
     * @type {BudgetLimitRequest}
     * @memberof LineItemRequest
     */
    'budget_limit'?: BudgetLimitRequest | null;
    /**
     * Monetary bid that the advertiser wants to pay based on the billing type of the particular placement. Each billing event generated by the tracking service is billed with the currently valid bid (i.e. added to the spent budget of the line item).
     * @type {number}
     * @memberof LineItemRequest
     */
    'bid_cents'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemRequest
     */
    'custom'?: any;
    /**
     * 
     * @type {Array<FrequencyCapConfig>}
     * @memberof LineItemRequest
     */
    'frequency_cap_configs'?: Array<FrequencyCapConfig>;
    /**
     * Uuid reference to the audience. NULL means no audience restriction, hence to target everyone.
     * @type {string}
     * @memberof LineItemRequest
     */
    'audience_id'?: string | null;
    /**
     * Uuid reference to the tenancy filter. NULL means line item is not assigned to a tenancy filter, hence it takes part in the auctioning process.
     * @type {string}
     * @memberof LineItemRequest
     */
    'tenancy_filter_id'?: string | null;
    /**
     * Headline text for native ad placement.
     * @type {string}
     * @memberof LineItemRequest
     */
    'headline'?: string | null;
    /**
     * Creatives URLs for a line item. The labels in the mapping need to match the object name created in the placement creatives configuration. Please ensure to only reference URLs to ad assets that adhere to the defined width and height in the placement, and conform to common ad standards in sizing (see [IAB](https://iabtechlab.com/standards/iab-new-ad-portfolio-guidelines/)). 
     * @type {{ [key: string]: LineItemCreativesValue; }}
     * @memberof LineItemRequest
     */
    'creatives'?: { [key: string]: LineItemCreativesValue; } | null;
    /**
     * URL for a potential external link.
     * @type {string}
     * @memberof LineItemRequest
     */
    'link_url'?: string | null;
    /**
     * The budget spending pacing determines how the line item\'s allocated budget is distributed over the duration of the campaign start and end date. `EVEN` Pacing: Ensures a balanced distribution of budget throughout the campaign. `ASAP` Pacing: Prioritizes spending the allocated budget as quickly as possible. This means that the budget may be exhausted well before the campaign end date. Use this option when immediate visibility and maximum exposure are primary goals. 
     * @type {string}
     * @memberof LineItemRequest
     */
    'pacing_type'?: LineItemRequestPacingTypeEnum;
    /**
     * Discount that applies to products in the line item. Can be monetary or percentual.
     * @type {number}
     * @memberof LineItemRequest
     */
    'discount_value'?: number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemRequest
     */
    'discount_type'?: LineItemRequestDiscountTypeEnum;
    /**
     * Define the additional targeting criteria for a line item to be returned. The configuration is a map of targeting keys to their boolean expressions. The targeting keys must match the regex `^[a-z0-9_]+$`, allowing only lowercase alphanumeric characters and underscores. Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: LineItemsCustomTargetingValue; }}
     * @memberof LineItemRequest
     */
    'custom_targeting'?: { [key: string]: LineItemsCustomTargetingValue; } | null;
    /**
     * A JSON object bound to the rules of the Custom Template of the placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof LineItemRequest
     */
    'custom_parameters'?: any;
    /**
     * 
     * @type {LineItemGoalRequest}
     * @memberof LineItemRequest
     */
    'goal'?: LineItemGoalRequest | null;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemRequest
     */
    'geo_targets'?: Array<GeoTargeting> | null;
    /**
     * 
     * @type {ScheduleRequest}
     * @memberof LineItemRequest
     */
    'schedule'?: ScheduleRequest | null;
}

export const LineItemRequestDeliveryModeEnum = {
    Auction: 'AUCTION',
    Guaranteed: 'GUARANTEED',
    HouseAd: 'HOUSE_AD'
} as const;

export type LineItemRequestDeliveryModeEnum = typeof LineItemRequestDeliveryModeEnum[keyof typeof LineItemRequestDeliveryModeEnum];
export const LineItemRequestBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type LineItemRequestBillingTypeEnum = typeof LineItemRequestBillingTypeEnum[keyof typeof LineItemRequestBillingTypeEnum];
export const LineItemRequestPacingTypeEnum = {
    Asap: 'ASAP',
    Even: 'EVEN'
} as const;

export type LineItemRequestPacingTypeEnum = typeof LineItemRequestPacingTypeEnum[keyof typeof LineItemRequestPacingTypeEnum];
export const LineItemRequestDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemRequestDiscountTypeEnum = typeof LineItemRequestDiscountTypeEnum[keyof typeof LineItemRequestDiscountTypeEnum];

/**
 * @type LineItemRequestCommitment
 * @export
 */
export type LineItemRequestCommitment = LineItemCommitment;

/**
 * An line item response
 * @export
 * @interface LineItemResponse
 */
export interface LineItemResponse {
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'id': string;
    /**
     * ID of the placement this line item bids for. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemResponse
     */
    'placement_id': string;
    /**
     * ID of the campaign this line item is part of. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemResponse
     */
    'campaign_id': string;
    /**
     * Status defined by the retailer. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof LineItemResponse
     */
    'retailer_status': LineItemResponseRetailerStatusEnum;
    /**
     * Approval status of the line item pending changes.
     * @type {string}
     * @memberof LineItemResponse
     */
    'retailer_approval': LineItemResponseRetailerApprovalEnum;
    /**
     * Status defined by the advertiser. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof LineItemResponse
     */
    'advertiser_status': LineItemResponseAdvertiserStatusEnum;
    /**
     * 
     * @type {Serving}
     * @memberof LineItemResponse
     */
    'serving': Serving;
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'approved_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'updated_at': string;
    /**
     * Can be used in the filter query string to filter by name. Case insensitive. Use % to search for a substring, e.g. `%promo%` to get both line items `Promo 50%` and `October promo`.
     * @type {string}
     * @memberof LineItemResponse
     */
    'name': string;
    /**
     * SKUs advertised by this line item. Can be used in the filter query string.
     * @type {Array<string>}
     * @memberof LineItemResponse
     */
    'advertised_skus'?: Array<string>;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemResponse
     */
    'target_category_keys'?: Array<string>;
    /**
     * Keywords describing this line item.
     * @type {Array<string>}
     * @memberof LineItemResponse
     */
    'keywords'?: Array<string>;
    /**
     * Specifies the ad delivery method for the line item. Ads are served either through an auction-based ranking (AUCTION) or via guaranteed delivery (GUARANTEED). House ads (HOUSE_AD) might be served when no other ads are available. Can be used in the filter query string. 
     * @type {string}
     * @memberof LineItemResponse
     */
    'delivery_mode'?: LineItemResponseDeliveryModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LineItemResponse
     */
    'billing_type'?: LineItemResponseBillingTypeEnum;
    /**
     * 
     * @type {LineItemRequestCommitment}
     * @memberof LineItemResponse
     */
    'commitment'?: LineItemRequestCommitment | null;
    /**
     * Line item total budget. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemResponse
     */
    'budget_total_cents'?: number | null;
    /**
     * Total budget left in cents. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemResponse
     */
    'budget_total_left_cents'?: number | null;
    /**
     * Total budget left as percentage of the total budget. Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemResponse
     */
    'budget_total_left_percent'?: number | null;
    /**
     * 
     * @type {BudgetLimitResponse}
     * @memberof LineItemResponse
     */
    'budget_limit'?: BudgetLimitResponse | null;
    /**
     * Monetary bid that the advertiser wants to pay based on the billing type of the particular placement. Each billing event generated by the tracking service is billed with the currently valid bid (i.e. added to the spent budget of the line item). Can be used in the filter query string.
     * @type {number}
     * @memberof LineItemResponse
     */
    'bid_cents'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemResponse
     */
    'custom'?: any;
    /**
     * 
     * @type {Array<FrequencyCapConfig>}
     * @memberof LineItemResponse
     */
    'frequency_cap_configs'?: Array<FrequencyCapConfig>;
    /**
     * Uuid reference to the audience. NULL means no audience restriction, hence to target everyone.
     * @type {string}
     * @memberof LineItemResponse
     */
    'audience_id'?: string | null;
    /**
     * Uuid reference to the tenancy filter. NULL means line item is not assigned to a tenancy filter, hence it takes part in the auctioning process. Can be used in the filter query string.
     * @type {string}
     * @memberof LineItemResponse
     */
    'tenancy_filter_id'?: string | null;
    /**
     * Message from the retailer.
     * @type {string}
     * @memberof LineItemResponse
     */
    'retailer_message'?: string | null;
    /**
     * Headline text at a native ad placement.
     * @type {string}
     * @memberof LineItemResponse
     */
    'headline'?: string | null;
    /**
     * Creatives URLs for a line item. The labels in the mapping need to match the object name created in the placement creatives configuration. Please ensure to only reference URLs to ad assets that adhere to the defined width and height in the placement, and conform to common ad standards in sizing (see [IAB](https://iabtechlab.com/standards/iab-new-ad-portfolio-guidelines/)). 
     * @type {{ [key: string]: LineItemCreativesValue; }}
     * @memberof LineItemResponse
     */
    'creatives'?: { [key: string]: LineItemCreativesValue; } | null;
    /**
     * For a potential external link (if allowed by the retailer).
     * @type {string}
     * @memberof LineItemResponse
     */
    'link_url'?: string | null;
    /**
     * Type of pacing of the line item.
     * @type {string}
     * @memberof LineItemResponse
     */
    'pacing_type': LineItemResponsePacingTypeEnum;
    /**
     * Discount that applies to products in the line item. Can be monetary or percentual.
     * @type {number}
     * @memberof LineItemResponse
     */
    'discount_value'?: number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemResponse
     */
    'discount_type'?: LineItemResponseDiscountTypeEnum;
    /**
     * Define the additional targeting criteria for a line item to be returned. The configuration is a map of targeting keys to their boolean expressions. The targeting keys must match the regex `^[a-z0-9_]+$`, allowing only lowercase alphanumeric characters and underscores. Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: LineItemsCustomTargetingValue; }}
     * @memberof LineItemResponse
     */
    'custom_targeting'?: { [key: string]: LineItemsCustomTargetingValue; } | null;
    /**
     * A JSON object bound to the rules of the Custom Template of the placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof LineItemResponse
     */
    'custom_parameters'?: any;
    /**
     * 
     * @type {LineItemPendingChangesResponse}
     * @memberof LineItemResponse
     */
    'pending_changes'?: LineItemPendingChangesResponse | null;
    /**
     * 
     * @type {LineItemGoalResponse}
     * @memberof LineItemResponse
     */
    'goal'?: LineItemGoalResponse | null;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemResponse
     */
    'geo_targets'?: Array<GeoTargeting> | null;
    /**
     * 
     * @type {ScheduleResponse}
     * @memberof LineItemResponse
     */
    'schedule'?: ScheduleResponse | null;
}

export const LineItemResponseRetailerStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type LineItemResponseRetailerStatusEnum = typeof LineItemResponseRetailerStatusEnum[keyof typeof LineItemResponseRetailerStatusEnum];
export const LineItemResponseRetailerApprovalEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type LineItemResponseRetailerApprovalEnum = typeof LineItemResponseRetailerApprovalEnum[keyof typeof LineItemResponseRetailerApprovalEnum];
export const LineItemResponseAdvertiserStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type LineItemResponseAdvertiserStatusEnum = typeof LineItemResponseAdvertiserStatusEnum[keyof typeof LineItemResponseAdvertiserStatusEnum];
export const LineItemResponseDeliveryModeEnum = {
    Auction: 'AUCTION',
    Guaranteed: 'GUARANTEED',
    HouseAd: 'HOUSE_AD'
} as const;

export type LineItemResponseDeliveryModeEnum = typeof LineItemResponseDeliveryModeEnum[keyof typeof LineItemResponseDeliveryModeEnum];
export const LineItemResponseBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type LineItemResponseBillingTypeEnum = typeof LineItemResponseBillingTypeEnum[keyof typeof LineItemResponseBillingTypeEnum];
export const LineItemResponsePacingTypeEnum = {
    Asap: 'ASAP',
    Even: 'EVEN'
} as const;

export type LineItemResponsePacingTypeEnum = typeof LineItemResponsePacingTypeEnum[keyof typeof LineItemResponsePacingTypeEnum];
export const LineItemResponseDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemResponseDiscountTypeEnum = typeof LineItemResponseDiscountTypeEnum[keyof typeof LineItemResponseDiscountTypeEnum];

/**
 * 
 * @export
 * @interface LineItemResponseWrapper
 */
export interface LineItemResponseWrapper {
    /**
     * 
     * @type {LineItemResponse}
     * @memberof LineItemResponseWrapper
     */
    'data'?: LineItemResponse;
}
/**
 * A patch for updating the retailer status of an line item. Use this to modify the approval or denial status and provide an optional message. 
 * @export
 * @interface LineItemRetailerStatusPatch
 */
export interface LineItemRetailerStatusPatch {
    /**
     * The updated retailer status of the line item.
     * @type {string}
     * @memberof LineItemRetailerStatusPatch
     */
    'retailer_status'?: LineItemRetailerStatusPatchRetailerStatusEnum;
    /**
     * The updated approval status of the line item pending changes.
     * @type {string}
     * @memberof LineItemRetailerStatusPatch
     */
    'retailer_approval'?: LineItemRetailerStatusPatchRetailerApprovalEnum;
    /**
     * An optional message that can be added to inform the Advertiser about the reason for denial or additional details on approval. 
     * @type {string}
     * @memberof LineItemRetailerStatusPatch
     */
    'retailer_message'?: string | null;
}

export const LineItemRetailerStatusPatchRetailerStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;

export type LineItemRetailerStatusPatchRetailerStatusEnum = typeof LineItemRetailerStatusPatchRetailerStatusEnum[keyof typeof LineItemRetailerStatusPatchRetailerStatusEnum];
export const LineItemRetailerStatusPatchRetailerApprovalEnum = {
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type LineItemRetailerStatusPatchRetailerApprovalEnum = typeof LineItemRetailerStatusPatchRetailerApprovalEnum[keyof typeof LineItemRetailerStatusPatchRetailerApprovalEnum];

/**
 * Line Item update request
 * @export
 * @interface LineItemUpdate
 */
export interface LineItemUpdate {
    /**
     * Line item name.
     * @type {string}
     * @memberof LineItemUpdate
     */
    'name': string;
    /**
     * SKUs advertised by the line item.
     * @type {Array<string>}
     * @memberof LineItemUpdate
     */
    'advertised_skus': Array<string> | null;
    /**
     * Category keys to target the line item for.
     * @type {Array<string>}
     * @memberof LineItemUpdate
     */
    'target_category_keys': Array<string> | null;
    /**
     * Keywords to target the line item. `keyword` means broad match (e.g. `pasta` will also target `pasta sauce`), `[keyword]` means exact match (e.g. `[pasta]` will only target `pasta` exactly and not target `pasta sauce`).
     * @type {Array<string>}
     * @memberof LineItemUpdate
     */
    'keywords': Array<string>;
    /**
     * Specifies the ad delivery method for the line item. Ads are served either through an auction-based ranking (AUCTION) or via guaranteed delivery (GUARANTEED). House ads (HOUSE_AD) can be used to fill ad slots when no other ads are available. Advertisers cannot change this field. 
     * @type {string}
     * @memberof LineItemUpdate
     */
    'delivery_mode'?: LineItemUpdateDeliveryModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LineItemUpdate
     */
    'billing_type': LineItemUpdateBillingTypeEnum;
    /**
     * 
     * @type {LineItemUpdateCommitment}
     * @memberof LineItemUpdate
     */
    'commitment'?: LineItemUpdateCommitment | null;
    /**
     * 
     * @type {number}
     * @memberof LineItemUpdate
     */
    'budget_total_cents': number | null;
    /**
     * 
     * @type {BudgetLimitPut}
     * @memberof LineItemUpdate
     */
    'budget_limit': BudgetLimitPut | null;
    /**
     * 
     * @type {number}
     * @memberof LineItemUpdate
     */
    'bid_cents': number | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemUpdate
     */
    'custom'?: any;
    /**
     * 
     * @type {Array<FrequencyCapConfig>}
     * @memberof LineItemUpdate
     */
    'frequency_cap_configs': Array<FrequencyCapConfig>;
    /**
     * 
     * @type {string}
     * @memberof LineItemUpdate
     */
    'audience_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof LineItemUpdate
     */
    'tenancy_filter_id': string | null;
    /**
     * Headline text at a native ad placement.
     * @type {string}
     * @memberof LineItemUpdate
     */
    'headline': string | null;
    /**
     * 
     * @type {any}
     * @memberof LineItemUpdate
     */
    'creatives': any;
    /**
     * For a potential external link (if allowed by the retailer).
     * @type {string}
     * @memberof LineItemUpdate
     */
    'link_url': string | null;
    /**
     * The budget spending pacing determines how the line item\'s allocated budget is distributed over the duration of the campaign start and end date. `EVEN` Pacing: Ensures a balanced distribution of budget throughout the campaign. `ASAP` Pacing: Prioritizes spending the allocated budget as quickly as possible. This means that the budget may be exhausted well before the campaign end date. Use this option when immediate visibility and maximum exposure are primary goals. 
     * @type {string}
     * @memberof LineItemUpdate
     */
    'pacing_type': LineItemUpdatePacingTypeEnum;
    /**
     * Discount that applies to products in the line item. Can be monetary or percentual.
     * @type {number}
     * @memberof LineItemUpdate
     */
    'discount_value': number | null;
    /**
     * Type of discount.
     * @type {string}
     * @memberof LineItemUpdate
     */
    'discount_type': LineItemUpdateDiscountTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof LineItemUpdate
     */
    'custom_targeting': any;
    /**
     * A JSON object bound to the rules of the Custom Template of the placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof LineItemUpdate
     */
    'custom_parameters': any;
    /**
     * 
     * @type {LineItemGoalUpdate}
     * @memberof LineItemUpdate
     */
    'goal': LineItemGoalUpdate | null;
    /**
     * Geographic targeting for the line item. Array of geo-fence definitions with latitude, longitude, and radius.
     * @type {Array<GeoTargeting>}
     * @memberof LineItemUpdate
     */
    'geo_targets': Array<GeoTargeting> | null;
    /**
     * 
     * @type {ScheduleUpdate}
     * @memberof LineItemUpdate
     */
    'schedule': ScheduleUpdate | null;
}

export const LineItemUpdateDeliveryModeEnum = {
    Auction: 'AUCTION',
    Guaranteed: 'GUARANTEED',
    HouseAd: 'HOUSE_AD'
} as const;

export type LineItemUpdateDeliveryModeEnum = typeof LineItemUpdateDeliveryModeEnum[keyof typeof LineItemUpdateDeliveryModeEnum];
export const LineItemUpdateBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type LineItemUpdateBillingTypeEnum = typeof LineItemUpdateBillingTypeEnum[keyof typeof LineItemUpdateBillingTypeEnum];
export const LineItemUpdatePacingTypeEnum = {
    Asap: 'ASAP',
    Even: 'EVEN'
} as const;

export type LineItemUpdatePacingTypeEnum = typeof LineItemUpdatePacingTypeEnum[keyof typeof LineItemUpdatePacingTypeEnum];
export const LineItemUpdateDiscountTypeEnum = {
    Percentage: 'PERCENTAGE',
    Absolute: 'ABSOLUTE'
} as const;

export type LineItemUpdateDiscountTypeEnum = typeof LineItemUpdateDiscountTypeEnum[keyof typeof LineItemUpdateDiscountTypeEnum];

/**
 * @type LineItemUpdateCommitment
 * @export
 */
export type LineItemUpdateCommitment = LineItemCommitment;

/**
 * 
 * @export
 * @interface LineItemsCustomTargetingValue
 */
export interface LineItemsCustomTargetingValue {
    /**
     * The boolean expression that will be evaluated to determine if the targeting is met. The expression must be different depending on the type of the targeting value. * `boolean` - Evaluates a boolean value. (e.g. `is_new_user`, to target only new users) * `integer` - Evaluates an integer value. (e.g. `age >= 25`, to target users older or equal to 25) * `string` - Evaluates a string value. (e.g `gender = \"male\"`, to target only men) * `integer_list` - Evaluates a list of integer values. (e.g. `200 in past_cart_values`, to target users who have spent at least 200 in the past) * `string_list` - Evaluates a list of string values. (e.g. `interests all of (\"music\", \"technology\")`), to target users interested in music and technology) More information about the boolean expression syntax can be found in the [documentation](https://docs.retailmediatools.com/reference/custom-targeting#defining-boolean-expressions-for-custom-targeting). 
     * @type {string}
     * @memberof LineItemsCustomTargetingValue
     */
    'boolean_expression': string;
}
/**
 * 
 * @export
 * @interface LineItemsResponseWrapper
 */
export interface LineItemsResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof LineItemsResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<LineItemListResponse>}
     * @memberof LineItemsResponseWrapper
     */
    'data'?: Array<LineItemListResponse>;
}
/**
 * Native advertising placement configuration
 * @export
 * @interface NativePlacementRequest
 */
export interface NativePlacementRequest {
    /**
     * The main name for the placement, recognizable by advertisers. Can be changed at any time.
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'type'?: NativePlacementRequestTypeEnum;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof NativePlacementRequest
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * Key of the catalog to which the placement is bound. Once set, cannot be changed.
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof NativePlacementRequest
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * Number of ads returned by the ad service. Can be changed later.
     * @type {number}
     * @memberof NativePlacementRequest
     */
    'ads_count': number;
    /**
     * Maximum headline length for the placement. If not set, headlines are disabled.
     * @type {number}
     * @memberof NativePlacementRequest
     */
    'max_headline_length'?: number | null;
    /**
     * Deprecated. Use the `creatives` configuration instead.
     * @type {boolean}
     * @memberof NativePlacementRequest
     * @deprecated
     */
    'has_creatives'?: boolean | null;
    /**
     * Does this placement allow discounts? Cannot be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_discounts': boolean | null;
    /**
     * Does this placement allow keyword filtering? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_keywords': boolean | null;
    /**
     * Does this placement allow audience filtering? Cannot be changed later.  To generate an accurate audience estimate, ensure a `catalog_key` is included in the placement configuration. Additionally, you must submit the `catalog_key` when you track an order. 
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_audience': boolean | null;
    /**
     * Does this placement allow geographic targeting? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_geo': boolean | null;
    /**
     * Does this placement allow dayparting? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_dayparting': boolean | null;
    /**
     * Deprecated. Use `category_targeting_mode` instead.
     * @type {boolean}
     * @memberof NativePlacementRequest
     * @deprecated
     */
    'has_categories'?: boolean | null;
    /**
     * Does this placement allow store filtering? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_stores': boolean | null;
    /**
     * Does this placement allow SKU filtering? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * Does this placement allow external links? Can be changed later.
     * @type {boolean}
     * @memberof NativePlacementRequest
     */
    'has_link_url': boolean | null;
    /**
     * Important: Please note that the `category_targeting_mode` controls how category-based targeting is configured and applied to placements. Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests.  In addition, `has_categories` field is no longer supported for `POST/PATCH/PUT` operations. However, it will still appear in `GET` responses when it is being returned, `has_categories` will be set to true if `category_targeting_mode` is active/set.  Three targeting modes are available:  **AUTOMATIC_SAME** (Automatic same-category targeting and serving) *  Booking: Advertisers cannot manually select categories. *  Serving: SKUs are automatically served to their respective assigned categories.  **SELECTIVE_SAME** (Manual, selective same-category targeting and serving) *  Booking: Advertisers can manually select categories, but only from categories that match the advertised SKUs. *  Serving: The system only serves SKUs within the selected categories, maintaining SKU-category matching.  **SELECTIVE_ALL** (Manual, all-category targeting and serving) *  Booking: Advertisers can manually select from any categories available in the placement\'s catalog. *  Serving: Ads are served to the selected target categories without enforcing SKU-to-category matching. 
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'category_targeting_mode'?: NativePlacementRequestCategoryTargetingModeEnum;
    /**
     * 
     * @type {PlacementCreatives}
     * @memberof NativePlacementRequest
     */
    'creatives'?: PlacementCreatives | null;
    /**
     * Main placement description for advertisers to understand and book. Can be changed any time.
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'description'?: string | null;
    /**
     * Visual placement preview for advertisers to recognize and book. Can be changed any time.
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'image_url'?: string | null;
    /**
     * Bid weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof NativePlacementRequest
     */
    'weight_bid'?: number | null;
    /**
     * Relevance weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof NativePlacementRequest
     */
    'weight_relevance'?: number | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof NativePlacementRequest
     */
    'group'?: string | null;
    /**
     * 
     * @type {PlacementsAttributionRequest}
     * @memberof NativePlacementRequest
     */
    'attribution'?: PlacementsAttributionRequest | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof NativePlacementRequest
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof NativePlacementRequest
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof NativePlacementRequest
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof NativePlacementRequest
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PreviewTemplates; }}
     * @memberof NativePlacementRequest
     */
    'preview_templates'?: { [key: string]: PreviewTemplates; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof NativePlacementRequest
     */
    'requires_approval'?: Array<NativePlacementRequestRequiresApprovalEnum>;
}

export const NativePlacementRequestTypeEnum = {
    Native: 'NATIVE'
} as const;

export type NativePlacementRequestTypeEnum = typeof NativePlacementRequestTypeEnum[keyof typeof NativePlacementRequestTypeEnum];
export const NativePlacementRequestCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type NativePlacementRequestCategoryTargetingModeEnum = typeof NativePlacementRequestCategoryTargetingModeEnum[keyof typeof NativePlacementRequestCategoryTargetingModeEnum];
export const NativePlacementRequestRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type NativePlacementRequestRequiresApprovalEnum = typeof NativePlacementRequestRequiresApprovalEnum[keyof typeof NativePlacementRequestRequiresApprovalEnum];

/**
 * 
 * @export
 * @interface PageInfoResponse
 */
export interface PageInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof PageInfoResponse
     */
    'next_cursor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PageInfoResponse
     */
    'prev_cursor'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PageInfoResponse
     */
    'total_count'?: number | null;
}
/**
 * This is the creatives settings for a placement. If not specified, ads served will not include any creative URLs. Can only be set when creating the placement. 
 * @export
 * @interface PlacementCreatives
 */
export interface PlacementCreatives {
    /**
     * This is a flexible label to creative configuration map. You can define your own object names such as desktop, tablet, mobile, digitalSignage, etc., or define it based on the ad type your creating via this placement. It currently holds the resolution configuration (width and height integer values). 
     * @type {{ [key: string]: CreativeProperties; }}
     * @memberof PlacementCreatives
     */
    'configuration': { [key: string]: CreativeProperties; };
}
/**
 * This is the creatives settings for a placement. If not specified, ads served will not include any creative URLs. Can only be set when creating the placement. 
 * @export
 * @interface PlacementCreativesResponse
 */
export interface PlacementCreativesResponse {
    /**
     * This is a flexible label to creative configuration map. You can define your own object names such as desktop, tablet, mobile, digitalSignage, etc., or define it based on the ad type your creating via this placement. It currently holds the resolution configuration (width and height integer values). 
     * @type {{ [key: string]: CreativeProperties; }}
     * @memberof PlacementCreativesResponse
     */
    'configuration': { [key: string]: CreativeProperties; };
}
/**
 * Request to get keyword suggestions for a set of products
 * @export
 * @interface PlacementKeywordSuggestionRequest
 */
export interface PlacementKeywordSuggestionRequest {
    /**
     * List of SKUs for which to get keyword suggestions
     * @type {Array<string>}
     * @memberof PlacementKeywordSuggestionRequest
     */
    'skus': Array<string>;
}
/**
 * 
 * @export
 * @interface PlacementKeywordSuggestionResponseWrapper
 */
export interface PlacementKeywordSuggestionResponseWrapper {
    /**
     * 
     * @type {Array<string>}
     * @memberof PlacementKeywordSuggestionResponseWrapper
     */
    'data'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PlacementKeywordsResponseWrapper
 */
export interface PlacementKeywordsResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof PlacementKeywordsResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlacementKeywordsResponseWrapper
     */
    'data'?: Array<string>;
}
/**
 * Represents a response for a placement.
 * @export
 * @interface PlacementListResponse
 */
export interface PlacementListResponse {
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'id': string;
    /**
     * Placement status. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof PlacementListResponse
     */
    'status': PlacementListResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'type'?: PlacementListResponseTypeEnum;
    /**
     * Allowed billing types with minimum bids
     * @type {Array<AllowedBilling>}
     * @memberof PlacementListResponse
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof PlacementListResponse
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PlacementListResponse
     */
    'ads_count': number;
    /**
     * Deprecated. Use the `creatives` configuration instead.
     * @type {boolean}
     * @memberof PlacementListResponse
     * @deprecated
     */
    'has_creatives'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_discounts': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_keywords': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_geo': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_dayparting': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_audience': boolean | null;
    /**
     * Deprecated. Use `category_targeting_mode` instead.
     * @type {boolean}
     * @memberof PlacementListResponse
     * @deprecated
     */
    'has_categories'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_stores': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementListResponse
     */
    'has_link_url': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PlacementListResponse
     */
    'max_headline_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'category_targeting_mode'?: PlacementListResponseCategoryTargetingModeEnum;
    /**
     * 
     * @type {PlacementCreativesResponse}
     * @memberof PlacementListResponse
     */
    'creatives'?: PlacementCreativesResponse | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementListResponse
     */
    'image_url'?: string | null;
    /**
     * Bid weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementListResponse
     */
    'weight_bid': number | null;
    /**
     * Relevance weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementListResponse
     */
    'weight_relevance': number | null;
    /**
     * 
     * @type {PlacementsAttributionResponse}
     * @memberof PlacementListResponse
     */
    'attribution'?: PlacementsAttributionResponse | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof PlacementListResponse
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * 
     * @type {PlacementsAdvancedSettings}
     * @memberof PlacementListResponse
     */
    'advanced_settings': PlacementsAdvancedSettings;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof PlacementListResponse
     */
    'requires_approval'?: Array<PlacementListResponseRequiresApprovalEnum>;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof PlacementListResponse
     */
    'group'?: string | null;
}

export const PlacementListResponseStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type PlacementListResponseStatusEnum = typeof PlacementListResponseStatusEnum[keyof typeof PlacementListResponseStatusEnum];
export const PlacementListResponseTypeEnum = {
    Spa: 'SPA',
    Display: 'DISPLAY',
    Native: 'NATIVE',
    Dooh: 'DOOH',
    Custom: 'CUSTOM'
} as const;

export type PlacementListResponseTypeEnum = typeof PlacementListResponseTypeEnum[keyof typeof PlacementListResponseTypeEnum];
export const PlacementListResponseCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type PlacementListResponseCategoryTargetingModeEnum = typeof PlacementListResponseCategoryTargetingModeEnum[keyof typeof PlacementListResponseCategoryTargetingModeEnum];
export const PlacementListResponseRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type PlacementListResponseRequiresApprovalEnum = typeof PlacementListResponseRequiresApprovalEnum[keyof typeof PlacementListResponseRequiresApprovalEnum];

/**
 * Response containing the minimum required bid for a placement, given the billing type and targeting configuration
 * @export
 * @interface PlacementMinBid
 */
export interface PlacementMinBid {
    /**
     * Minimum required bid based on the desired billing type and target categories.
     * @type {number}
     * @memberof PlacementMinBid
     */
    'bid_cents'?: number | null;
    /**
     * Category key whose min bid dictated the result.
     * @type {string}
     * @memberof PlacementMinBid
     */
    'category_key'?: string | null;
}
/**
 * Request to get the minimum required bid for a placement, given the billing type and targeting configuration
 * @export
 * @interface PlacementMinBidRequest
 */
export interface PlacementMinBidRequest {
    /**
     * Line item billing type
     * @type {string}
     * @memberof PlacementMinBidRequest
     */
    'billing_type': PlacementMinBidRequestBillingTypeEnum;
    /**
     * List of line item target category keys
     * @type {Array<string>}
     * @memberof PlacementMinBidRequest
     */
    'target_category_keys': Array<string>;
}

export const PlacementMinBidRequestBillingTypeEnum = {
    Cpm: 'CPM',
    Click: 'CLICK',
    AddToCart: 'ADD_TO_CART'
} as const;

export type PlacementMinBidRequestBillingTypeEnum = typeof PlacementMinBidRequestBillingTypeEnum[keyof typeof PlacementMinBidRequestBillingTypeEnum];

/**
 * 
 * @export
 * @interface PlacementMinBidResponseWrapper
 */
export interface PlacementMinBidResponseWrapper {
    /**
     * 
     * @type {PlacementMinBid}
     * @memberof PlacementMinBidResponseWrapper
     */
    'data'?: PlacementMinBid;
}
/**
 * Update input for a placement
 * @export
 * @interface PlacementPatchUpdate
 */
export interface PlacementPatchUpdate {
    /**
     * The status of the placement.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'status'?: PlacementPatchUpdateStatusEnum;
    /**
     * Key of the catalog the placement is bound to.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'catalog_key'?: string | null;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof PlacementPatchUpdate
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * List of advertiser IDs allowed for the placement.
     * @type {Array<string>}
     * @memberof PlacementPatchUpdate
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * The name of the placement.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'name'?: string | null;
    /**
     * Number of ads returned by the ad service.
     * @type {number}
     * @memberof PlacementPatchUpdate
     */
    'ads_count'?: number | null;
    /**
     * Indicates if the placement allows keyword filtering.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_keywords'?: boolean | null;
    /**
     * Indicates if the placement allows geographic targeting.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_geo'?: boolean | null;
    /**
     * Indicates if the placement allows dayparting.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_dayparting'?: boolean | null;
    /**
     * Indicates if the placement allows store filtering.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_stores'?: boolean | null;
    /**
     * Indicates if the placement allows SKU filtering.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_skus'?: boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available. Null falls back to catalog presence; false hides it even with a catalog.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * Indicates if the placement allows external links.
     * @type {boolean}
     * @memberof PlacementPatchUpdate
     */
    'has_link_url'?: boolean | null;
    /**
     * The description of the placement.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'description'?: string | null;
    /**
     * The URL for the visual placement preview.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'image_url'?: string | null;
    /**
     * Maximum headline length for the placement.
     * @type {number}
     * @memberof PlacementPatchUpdate
     */
    'max_headline_length'?: number | null;
    /**
     * Bid weight for this placement. Controls the ratio between showing ads based on bid or relevance. You can start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementPatchUpdate
     */
    'weight_bid'?: number | null;
    /**
     * Relevance weight for this placement. Controls the ratio between showing ads based on bid or relevance. You can start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementPatchUpdate
     */
    'weight_relevance'?: number | null;
    /**
     * 
     * @type {PlacementsAttributionRequest}
     * @memberof PlacementPatchUpdate
     */
    'attribution'?: PlacementsAttributionRequest | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof PlacementPatchUpdate
     */
    'group'?: string | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof PlacementPatchUpdate
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof PlacementPatchUpdate
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof PlacementPatchUpdate
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof PlacementPatchUpdate
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PreviewTemplates; }}
     * @memberof PlacementPatchUpdate
     */
    'preview_templates'?: { [key: string]: PreviewTemplates; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof PlacementPatchUpdate
     */
    'requires_approval'?: Array<PlacementPatchUpdateRequiresApprovalEnum>;
}

export const PlacementPatchUpdateStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type PlacementPatchUpdateStatusEnum = typeof PlacementPatchUpdateStatusEnum[keyof typeof PlacementPatchUpdateStatusEnum];
export const PlacementPatchUpdateRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type PlacementPatchUpdateRequiresApprovalEnum = typeof PlacementPatchUpdateRequiresApprovalEnum[keyof typeof PlacementPatchUpdateRequiresApprovalEnum];

/**
 * @type PlacementRequest
 * @export
 */
export type PlacementRequest = { type: 'CUSTOM' } & CustomPlacementRequest | { type: 'DISPLAY' } & DisplayPlacementRequest | { type: 'DOOH' } & DOOHPlacementRequest | { type: 'NATIVE' } & NativePlacementRequest | { type: 'SPA' } & SPAPlacementRequest;

/**
 * Represents a response for a placement.
 * @export
 * @interface PlacementResponse
 */
export interface PlacementResponse {
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'id': string;
    /**
     * Placement status. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof PlacementResponse
     */
    'status': PlacementResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'type'?: PlacementResponseTypeEnum;
    /**
     * Allowed billing types with minimum bids
     * @type {Array<AllowedBilling>}
     * @memberof PlacementResponse
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof PlacementResponse
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PlacementResponse
     */
    'ads_count': number;
    /**
     * Deprecated. Use the `creatives` configuration instead.
     * @type {boolean}
     * @memberof PlacementResponse
     * @deprecated
     */
    'has_creatives'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_discounts': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_keywords': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_audience': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_geo': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_dayparting': boolean | null;
    /**
     * Deprecated. Use `category_targeting_mode` instead.
     * @type {boolean}
     * @memberof PlacementResponse
     * @deprecated
     */
    'has_categories'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_stores': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementResponse
     */
    'has_link_url': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'category_targeting_mode'?: PlacementResponseCategoryTargetingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof PlacementResponse
     */
    'max_headline_length'?: number | null;
    /**
     * 
     * @type {PlacementCreativesResponse}
     * @memberof PlacementResponse
     */
    'creatives'?: PlacementCreativesResponse | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementResponse
     */
    'image_url'?: string | null;
    /**
     * Bid weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementResponse
     */
    'weight_bid': number | null;
    /**
     * Relevance weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementResponse
     */
    'weight_relevance': number | null;
    /**
     * 
     * @type {PlacementsAttributionResponse}
     * @memberof PlacementResponse
     */
    'attribution'?: PlacementsAttributionResponse | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof PlacementResponse
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide.
     * @type {any}
     * @memberof PlacementResponse
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettings}
     * @memberof PlacementResponse
     */
    'advanced_settings': PlacementsAdvancedSettings;
    /**
     * 
     * @type {PlacementsGuidelinesResponse}
     * @memberof PlacementResponse
     */
    'guidelines'?: PlacementsGuidelinesResponse;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PlacementsPreviewTemplatesResponseValue; }}
     * @memberof PlacementResponse
     */
    'preview_templates'?: { [key: string]: PlacementsPreviewTemplatesResponseValue; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof PlacementResponse
     */
    'requires_approval'?: Array<PlacementResponseRequiresApprovalEnum>;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof PlacementResponse
     */
    'group'?: string | null;
}

export const PlacementResponseStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type PlacementResponseStatusEnum = typeof PlacementResponseStatusEnum[keyof typeof PlacementResponseStatusEnum];
export const PlacementResponseTypeEnum = {
    Spa: 'SPA',
    Display: 'DISPLAY',
    Native: 'NATIVE',
    Dooh: 'DOOH',
    Custom: 'CUSTOM'
} as const;

export type PlacementResponseTypeEnum = typeof PlacementResponseTypeEnum[keyof typeof PlacementResponseTypeEnum];
export const PlacementResponseCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type PlacementResponseCategoryTargetingModeEnum = typeof PlacementResponseCategoryTargetingModeEnum[keyof typeof PlacementResponseCategoryTargetingModeEnum];
export const PlacementResponseRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type PlacementResponseRequiresApprovalEnum = typeof PlacementResponseRequiresApprovalEnum[keyof typeof PlacementResponseRequiresApprovalEnum];

/**
 * 
 * @export
 * @interface PlacementResponseWrapper
 */
export interface PlacementResponseWrapper {
    /**
     * 
     * @type {PlacementResponse}
     * @memberof PlacementResponseWrapper
     */
    'data'?: PlacementResponse;
}
/**
 * Represents an update input for a placement.
 * @export
 * @interface PlacementUpdate
 */
export interface PlacementUpdate {
    /**
     * 
     * @type {string}
     * @memberof PlacementUpdate
     */
    'status': PlacementUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PlacementUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlacementUpdate
     */
    'catalog_key': string | null;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof PlacementUpdate
     */
    'allowed_billings': Array<AllowedBilling> | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof PlacementUpdate
     */
    'allowed_advertiser_ids': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PlacementUpdate
     */
    'ads_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_keywords': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_geo': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_dayparting'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_stores': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlacementUpdate
     */
    'has_link_url': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementUpdate
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof PlacementUpdate
     */
    'image_url': string | null;
    /**
     * 
     * @type {number}
     * @memberof PlacementUpdate
     */
    'max_headline_length': number | null;
    /**
     * Bid weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementUpdate
     */
    'weight_bid': number | null;
    /**
     * Relevance weight for this placement. Controls the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof PlacementUpdate
     */
    'weight_relevance': number | null;
    /**
     * 
     * @type {PlacementsAttributionUpdate}
     * @memberof PlacementUpdate
     */
    'attribution': PlacementsAttributionUpdate | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof PlacementUpdate
     */
    'group': string | null;
    /**
     * 
     * @type {any}
     * @memberof PlacementUpdate
     */
    'custom_targeting': any;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide.
     * @type {any}
     * @memberof PlacementUpdate
     */
    'custom_template': any;
    /**
     * 
     * @type {PlacementsAdvancedSettings}
     * @memberof PlacementUpdate
     */
    'advanced_settings': PlacementsAdvancedSettings;
    /**
     * 
     * @type {PlacementsGuidelinesUpdate}
     * @memberof PlacementUpdate
     */
    'guidelines': PlacementsGuidelinesUpdate;
    /**
     * Collection of html templates for advertisers to preview the placement.
     * @type {{ [key: string]: PreviewTemplates; }}
     * @memberof PlacementUpdate
     */
    'preview_templates': { [key: string]: PreviewTemplates; } | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof PlacementUpdate
     */
    'requires_approval': Array<PlacementUpdateRequiresApprovalEnum>;
}

export const PlacementUpdateStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type PlacementUpdateStatusEnum = typeof PlacementUpdateStatusEnum[keyof typeof PlacementUpdateStatusEnum];
export const PlacementUpdateRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    Headline: 'headline',
    Creatives: 'creatives',
    LinkUrl: 'link_url',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type PlacementUpdateRequiresApprovalEnum = typeof PlacementUpdateRequiresApprovalEnum[keyof typeof PlacementUpdateRequiresApprovalEnum];

/**
 * Advanced settings for a placement. If not specified, the default settings will be used. 
 * @export
 * @interface PlacementsAdvancedSettings
 */
export interface PlacementsAdvancedSettings {
    /**
     * Enable pacing for the placement. If enabled, advertisers can set the pacing type for the line items in the placement. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'allow_pacing': boolean | null;
    /**
     * Show inventory for the placement. If enabled, the products inventory will be visible to the advertiser while creating line items. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'show_inventory': boolean | null;
    /**
     * Serve SKUs as line items. If enabled, single SKUs will be served in ad serving instead of unique line items. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'serve_skus': boolean | null;
    /**
     * Automatic keyword SKUs match. If enabled, keyword targeting is automatically optimized with AI to match on SKU level (based on product information like name, brand and categories). 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'auto_keyword_skus_match': boolean | null;
    /**
     * Disable ad cache for the placement. If enabled, ad requests with session key will not return ads from the cache. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'disable_ad_cache': boolean | null;
    /**
     * Enable auto-bidding for the placement. If enabled, the placement will allow bid on the line items based on the advertiser\'s budget and campaign goal. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'auto_bidding': boolean | null;
    /**
     * Enable frequency capping for the placement. When enabled, line items within the placement will be excluded once their configured maximum impressions have been reached for the current period. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'allow_frequency_capping': boolean | null;
    /**
     * Controls forecasting availability for this placement. - disabled: Forecasting is not available - retailer_only: Only retailers can use forecasting - retailer_and_advertisers: Both retailers and advertisers can use forecasting 
     * @type {string}
     * @memberof PlacementsAdvancedSettings
     */
    'forecasting_mode': PlacementsAdvancedSettingsForecastingModeEnum;
    /**
     * Bill per unique (ad_id, sku) instead of per ad_id. If enabled, each unique SKU shown under the same ad (e.g. in a carousel or collection) is billed separately instead of being deduplicated to a single billable event per ad. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettings
     */
    'bill_per_sku': boolean | null;
}

export const PlacementsAdvancedSettingsForecastingModeEnum = {
    Disabled: 'disabled',
    RetailerOnly: 'retailer_only',
    RetailerAndAdvertisers: 'retailer_and_advertisers'
} as const;

export type PlacementsAdvancedSettingsForecastingModeEnum = typeof PlacementsAdvancedSettingsForecastingModeEnum[keyof typeof PlacementsAdvancedSettingsForecastingModeEnum];

/**
 * Advanced settings for a placement. If not specified, the default settings will be used. 
 * @export
 * @interface PlacementsAdvancedSettingsRequest
 */
export interface PlacementsAdvancedSettingsRequest {
    /**
     * Enable pacing for the placement. If enabled, advertisers can set the pacing type for the line items in the placement. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'allow_pacing': boolean | null;
    /**
     * Show inventory for the placement. If enabled, the products inventory will be visible to the advertiser while creating line items. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'show_inventory': boolean | null;
    /**
     * Serve SKUs as line items. If enabled, single SKUs will be served in ad serving instead of unique line items. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'serve_skus': boolean | null;
    /**
     * Automatic keyword SKUs match. If enabled, keyword targeting is automatically optimized with AI to match on SKU level (based on product information like name, description, brand and categories). 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'auto_keyword_skus_match': boolean | null;
    /**
     * Disable ad cache for the placement. If enabled, ad requests with session key will not return ads from the cache. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'disable_ad_cache': boolean | null;
    /**
     * Enable auto-bidding for the placement. If enabled, the placement will allow bid on the line items based on the advertiser\'s budget and campaign goal. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'auto_bidding': boolean | null;
    /**
     * Enable frequency capping for the placement. When enabled, line items within the placement will be excluded once their configured maximum impressions have been reached for the current period. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'allow_frequency_capping': boolean | null;
    /**
     * Controls forecasting availability for this placement. - disabled: Forecasting is not available - retailer_only: Only retailers can use forecasting - retailer_and_advertisers: Both retailers and advertisers can use forecasting 
     * @type {string}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'forecasting_mode': PlacementsAdvancedSettingsRequestForecastingModeEnum;
    /**
     * Bill per unique (ad_id, sku) instead of per ad_id. If enabled, each unique SKU shown under the same ad (e.g. in a carousel or collection) is billed separately instead of being deduplicated to a single billable event per ad. 
     * @type {boolean}
     * @memberof PlacementsAdvancedSettingsRequest
     */
    'bill_per_sku': boolean | null;
}

export const PlacementsAdvancedSettingsRequestForecastingModeEnum = {
    Disabled: 'disabled',
    RetailerOnly: 'retailer_only',
    RetailerAndAdvertisers: 'retailer_and_advertisers'
} as const;

export type PlacementsAdvancedSettingsRequestForecastingModeEnum = typeof PlacementsAdvancedSettingsRequestForecastingModeEnum[keyof typeof PlacementsAdvancedSettingsRequestForecastingModeEnum];

/**
 * Attribution settings for a placement. If not specified, no attribution will be performed. Once specified, the attribution settings cannot be changed. 
 * @export
 * @interface PlacementsAttributionRequest
 */
export interface PlacementsAttributionRequest {
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionRequest
     */
    'post_click': PlacementsAttributionSettings | null;
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionRequest
     */
    'post_view': PlacementsAttributionSettings | null;
}
/**
 * Attribution settings for a placement. If not specified, no attribution will be performed. Once specified, the attribution settings cannot be changed. 
 * @export
 * @interface PlacementsAttributionResponse
 */
export interface PlacementsAttributionResponse {
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionResponse
     */
    'post_click': PlacementsAttributionSettings | null;
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionResponse
     */
    'post_view': PlacementsAttributionSettings | null;
}
/**
 * Attribution settings. The attribution settings can be defined for post_click and post_view modes. 
 * @export
 * @interface PlacementsAttributionSettings
 */
export interface PlacementsAttributionSettings {
    /**
     * The number of days to look back for attribution. For example, if the lookback window is 7 days, then orders placed within 7 days of the ad view or click are attributed to the ad.
     * @type {number}
     * @memberof PlacementsAttributionSettings
     */
    'lookback_window_days': number;
    /**
     * * `SKU` - Orders are attributed to ads from line items in this placement if the order contains the SKU of the advertised product, * `CATEGORY` - Orders are attributed to ads from line items in this placement if the order contains the category of the advertised product, and * `BRAND` - Orders are attributed to ads from line items in this placement if the order contains the brand of the advertised product. 
     * @type {string}
     * @memberof PlacementsAttributionSettings
     */
    'product_match': PlacementsAttributionSettingsProductMatchEnum;
}

export const PlacementsAttributionSettingsProductMatchEnum = {
    Sku: 'SKU',
    Category: 'CATEGORY',
    Brand: 'BRAND'
} as const;

export type PlacementsAttributionSettingsProductMatchEnum = typeof PlacementsAttributionSettingsProductMatchEnum[keyof typeof PlacementsAttributionSettingsProductMatchEnum];

/**
 * Attribution settings for a placement. If not specified, no attribution will be performed. Once specified, the attribution settings cannot be changed. 
 * @export
 * @interface PlacementsAttributionUpdate
 */
export interface PlacementsAttributionUpdate {
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionUpdate
     */
    'post_click': PlacementsAttributionSettings | null;
    /**
     * 
     * @type {PlacementsAttributionSettings}
     * @memberof PlacementsAttributionUpdate
     */
    'post_view': PlacementsAttributionSettings | null;
}
/**
 * 
 * @export
 * @interface PlacementsCustomTargetingRequestValue
 */
export interface PlacementsCustomTargetingRequestValue {
    /**
     * The type of the targeting value that is expected on the ad requests: * `boolean` - A boolean value. (e.g. `{\"is_new_user\": true}`) * `integer` - An integer value. (e.g. `{\"age\": 34}`) * `string` - A string value. (e.g. `{\"gender\": \"female\"}`) * `integer_list` - A list of integer values. (e.g. `{\"past_cart_values\": [10, 100, 200]}`) * `string_list` - A list of string values. (e.g. `{\"interests\": [\"music\", \"sports\"]}`) More information about custom targeting can be found in the [documentation](https://docs.retailmediatools.com/reference/custom-targeting). 
     * @type {string}
     * @memberof PlacementsCustomTargetingRequestValue
     */
    'type': PlacementsCustomTargetingRequestValueTypeEnum;
    /**
     * The list of values that the targeting value can take. This is not used for any API validation, but for documentation/UI purposes. 
     * @type {Array<string>}
     * @memberof PlacementsCustomTargetingRequestValue
     */
    'enum'?: Array<string> | null;
    /**
     * An optional title for the targeting key, for documentation/UI purposes.
     * @type {string}
     * @memberof PlacementsCustomTargetingRequestValue
     */
    'title'?: string | null;
    /**
     * An optional description for the targeting key, for documentation/UI purposes.
     * @type {string}
     * @memberof PlacementsCustomTargetingRequestValue
     */
    'description'?: string | null;
}

export const PlacementsCustomTargetingRequestValueTypeEnum = {
    Boolean: 'boolean',
    Integer: 'integer',
    String: 'string',
    IntegerList: 'integer_list',
    StringList: 'string_list'
} as const;

export type PlacementsCustomTargetingRequestValueTypeEnum = typeof PlacementsCustomTargetingRequestValueTypeEnum[keyof typeof PlacementsCustomTargetingRequestValueTypeEnum];

/**
 * Guidelines for advertisers when creating line items in this placement. These are HTML formatted text that will be displayed to advertisers during line item creation. 
 * @export
 * @interface PlacementsGuidelinesRequest
 */
export interface PlacementsGuidelinesRequest {
    /**
     * Guidelines for keywords to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them choose effective keywords that align with the placement\'s targeting strategy and comply with any keyword policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesRequest
     */
    'keywords'?: string | null;
    /**
     * Guidelines for creatives to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them create effective creatives that align with the placement\'s visual requirements, brand standards, and comply with any creative policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesRequest
     */
    'creatives'?: string | null;
}
/**
 * Guidelines for advertisers when creating line items in this placement. These are HTML formatted text that will be displayed to advertisers during line item creation. 
 * @export
 * @interface PlacementsGuidelinesResponse
 */
export interface PlacementsGuidelinesResponse {
    /**
     * Guidelines for keywords to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them choose effective keywords that align with the placement\'s targeting strategy and comply with any keyword policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesResponse
     */
    'keywords'?: string | null;
    /**
     * Guidelines for creatives to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them create effective creatives that align with the placement\'s visual requirements, brand standards, and comply with any creative policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesResponse
     */
    'creatives'?: string | null;
}
/**
 * Guidelines for advertisers when creating line items in this placement. These are HTML formatted text that will be displayed to advertisers during line item creation. 
 * @export
 * @interface PlacementsGuidelinesUpdate
 */
export interface PlacementsGuidelinesUpdate {
    /**
     * Guidelines for keywords to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them choose effective keywords that align with the placement\'s targeting strategy and comply with any keyword policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesUpdate
     */
    'keywords'?: string | null;
    /**
     * Guidelines for creatives to be used in line items for this placement. These are HTML-formatted instructions displayed to advertisers during line item creation, helping them create effective creatives that align with the placement\'s visual requirements, brand standards, and comply with any creative policies or best practices. 
     * @type {string}
     * @memberof PlacementsGuidelinesUpdate
     */
    'creatives'?: string | null;
}
/**
 * 
 * @export
 * @interface PlacementsPreviewTemplatesResponseValue
 */
export interface PlacementsPreviewTemplatesResponseValue {
    /**
     * A human readable title for the preview template. 
     * @type {string}
     * @memberof PlacementsPreviewTemplatesResponseValue
     */
    'title'?: string;
    /**
     * The HTML template for the preview. This template will be used to render the preview of the placement. 
     * @type {string}
     * @memberof PlacementsPreviewTemplatesResponseValue
     */
    'html_template': string;
}
/**
 * 
 * @export
 * @interface PlacementsResponseWrapper
 */
export interface PlacementsResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof PlacementsResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<PlacementListResponse>}
     * @memberof PlacementsResponseWrapper
     */
    'data'?: Array<PlacementListResponse>;
}
/**
 * 
 * @export
 * @interface PreviewTemplates
 */
export interface PreviewTemplates {
    /**
     * A human readable title for the preview template. 
     * @type {string}
     * @memberof PreviewTemplates
     */
    'title'?: string;
    /**
     * The HTML template for the preview. This template will be used to render the preview of the placement. 
     * @type {string}
     * @memberof PreviewTemplates
     */
    'html_template': string;
}
/**
 * Sponsored Product Ads placement configuration
 * @export
 * @interface SPAPlacementRequest
 */
export interface SPAPlacementRequest {
    /**
     * The main name for the placement, recognizable by advertisers. Can be changed at any time.
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'name': string;
    /**
     * The type of placement.
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'type'?: SPAPlacementRequestTypeEnum;
    /**
     * Allowed billing types with minimum bids.
     * @type {Array<AllowedBilling>}
     * @memberof SPAPlacementRequest
     */
    'allowed_billings'?: Array<AllowedBilling> | null;
    /**
     * Key of the catalog to which the placement is bound. Once set, cannot be changed.
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'catalog_key'?: string | null;
    /**
     * Indicates if this placement is only visible to specified advertisers.
     * @type {Array<string>}
     * @memberof SPAPlacementRequest
     */
    'allowed_advertiser_ids'?: Array<string> | null;
    /**
     * Number of ads returned by the ad service. Can be changed later.
     * @type {number}
     * @memberof SPAPlacementRequest
     */
    'ads_count': number;
    /**
     * Does this placement allow discounts? Cannot be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_discounts': boolean | null;
    /**
     * Does this placement allow keyword filtering? Can be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_keywords': boolean | null;
    /**
     * Does this placement allow audience filtering? Cannot be changed later.  To generate an accurate audience estimate, ensure a `catalog_key` is included in the placement configuration. Additionally, you must submit the `catalog_key` when you track an order. 
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_audience': boolean | null;
    /**
     * Does this placement allow geographic targeting? Can be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_geo': boolean | null;
    /**
     * Does this placement allow dayparting? Can be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_dayparting': boolean | null;
    /**
     * Deprecated. Use `category_targeting_mode` instead.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     * @deprecated
     */
    'has_categories'?: boolean | null;
    /**
     * Does this placement allow store filtering? Can be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_stores': boolean | null;
    /**
     * Does this placement allow SKU filtering? Can be changed later.
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_skus': boolean | null;
    /**
     * Controls whether the Product Selection (advertised SKUs) step is available in the line item create/edit/clone flows. When null (the default), the step is shown implicitly whenever the placement has a `catalog_key`, and hidden otherwise. When explicitly `false`, the step is hidden even if a `catalog_key` is set. When `true`, the step is shown (a `catalog_key` must be present for product selection to function). 
     * @type {boolean}
     * @memberof SPAPlacementRequest
     */
    'has_advertised_skus'?: boolean | null;
    /**
     * Important: Please note that the `category_targeting_mode` controls how category-based targeting is configured and applied to placements. Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests.  In addition, `has_categories` field is no longer supported for `POST/PATCH/PUT` operations. However, it will still appear in `GET` responses when it is being returned, `has_categories` will be set to true if `category_targeting_mode` is active/set.  Three targeting modes are available:  **AUTOMATIC_SAME** (Automatic same-category targeting and serving) *  Booking: Advertisers cannot manually select categories. *  Serving: SKUs are automatically served to their respective assigned categories.  **SELECTIVE_SAME** (Manual, selective same-category targeting and serving) *  Booking: Advertisers can manually select categories, but only from categories that match the advertised SKUs. *  Serving: The system only serves SKUs within the selected categories, maintaining SKU-category matching.  **SELECTIVE_ALL** (Manual, all-category targeting and serving) *  Booking: Advertisers can manually select from any categories available in the placement\'s catalog. *  Serving: Ads are served to the selected target categories without enforcing SKU-to-category matching. 
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'category_targeting_mode'?: SPAPlacementRequestCategoryTargetingModeEnum;
    /**
     * Main placement description for advertisers to understand and book. Can be changed any time.
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'description'?: string | null;
    /**
     * Bid weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof SPAPlacementRequest
     */
    'weight_bid'?: number | null;
    /**
     * Relevance weight for this placement, controlling the ratio between showing ads based on bid or relevance. We recommend to start with 100/100 and change it later if necessary.
     * @type {number}
     * @memberof SPAPlacementRequest
     */
    'weight_relevance'?: number | null;
    /**
     * Group placements together by setting the same group name.
     * @type {string}
     * @memberof SPAPlacementRequest
     */
    'group'?: string | null;
    /**
     * 
     * @type {PlacementsAttributionRequest}
     * @memberof SPAPlacementRequest
     */
    'attribution'?: PlacementsAttributionRequest | null;
    /**
     * Define the additional targeting criteria for a placement. The configuration is a map of targeting keys to their configuration. The targeting keys must match the regex `^[a-z_][a-z0-9_]*$`, allowing only lowercase alphanumeric characters and underscores (must start with a letter or underscore). Maximum 5 custom targeting keys can be set. 
     * @type {{ [key: string]: PlacementsCustomTargetingRequestValue; }}
     * @memberof SPAPlacementRequest
     */
    'custom_targeting'?: { [key: string]: PlacementsCustomTargetingRequestValue; } | null;
    /**
     * A JSON schema that defines the template for line items in a given placement. You can find more details on setting up a Custom Template and the available options in the [Custom Parameters Template](https://docs.retailmediatools.com/reference/custom-parameters-templates) guide. 
     * @type {any}
     * @memberof SPAPlacementRequest
     */
    'custom_template'?: any;
    /**
     * 
     * @type {PlacementsAdvancedSettingsRequest}
     * @memberof SPAPlacementRequest
     */
    'advanced_settings'?: PlacementsAdvancedSettingsRequest | null;
    /**
     * 
     * @type {PlacementsGuidelinesRequest}
     * @memberof SPAPlacementRequest
     */
    'guidelines'?: PlacementsGuidelinesRequest | null;
    /**
     * List of line items fields that require retailer approval after being changed. Empty list means that the line items will be approved automatically on creation. Can be changed later. 
     * @type {Array<string>}
     * @memberof SPAPlacementRequest
     */
    'requires_approval'?: Array<SPAPlacementRequestRequiresApprovalEnum>;
}

export const SPAPlacementRequestTypeEnum = {
    Spa: 'SPA'
} as const;

export type SPAPlacementRequestTypeEnum = typeof SPAPlacementRequestTypeEnum[keyof typeof SPAPlacementRequestTypeEnum];
export const SPAPlacementRequestCategoryTargetingModeEnum = {
    AutomaticSame: 'AUTOMATIC_SAME',
    SelectiveSame: 'SELECTIVE_SAME',
    SelectiveAll: 'SELECTIVE_ALL'
} as const;

export type SPAPlacementRequestCategoryTargetingModeEnum = typeof SPAPlacementRequestCategoryTargetingModeEnum[keyof typeof SPAPlacementRequestCategoryTargetingModeEnum];
export const SPAPlacementRequestRequiresApprovalEnum = {
    AdvertisedSkus: 'advertised_skus',
    Keywords: 'keywords',
    AudienceId: 'audience_id',
    DiscountValue: 'discount_value',
    DiscountType: 'discount_type',
    CustomTargeting: 'custom_targeting',
    TargetCategoryKeys: 'target_category_keys',
    CustomParameters: 'custom_parameters',
    GeoTargets: 'geo_targets',
    Schedule: 'schedule'
} as const;

export type SPAPlacementRequestRequiresApprovalEnum = typeof SPAPlacementRequestRequiresApprovalEnum[keyof typeof SPAPlacementRequestRequiresApprovalEnum];

/**
 * Ad serving schedule defining active hours for each day of the week.
 * @export
 * @interface ScheduleRequest
 */
export interface ScheduleRequest {
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'monday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'tuesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'wednesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'thursday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'friday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'saturday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleRequest
     */
    'sunday': Array<number>;
}
/**
 * Ad serving schedule defining active hours for each day of the week.
 * @export
 * @interface ScheduleResponse
 */
export interface ScheduleResponse {
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'monday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'tuesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'wednesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'thursday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'friday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'saturday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleResponse
     */
    'sunday': Array<number>;
}
/**
 * Ad serving schedule defining active hours for each day of the week.
 * @export
 * @interface ScheduleUpdate
 */
export interface ScheduleUpdate {
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'monday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'tuesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'wednesday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'thursday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'friday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'saturday': Array<number>;
    /**
     * List of hours (0-23) representing the active hours for a specific day.
     * @type {Array<number>}
     * @memberof ScheduleUpdate
     */
    'sunday': Array<number>;
}
/**
 * Represents the serving status of a line item, indicating whether it is currently being served. Can be used in the filter query string via `serving.status`. Multiple choice filter is allowed. 
 * @export
 * @interface Serving
 */
export interface Serving {
    /**
     * 
     * @type {string}
     * @memberof Serving
     */
    'status': ServingStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Serving
     */
    'reasons'?: Array<string> | null;
}

export const ServingStatusEnum = {
    NotServing: 'NOT_SERVING',
    Serving: 'SERVING'
} as const;

export type ServingStatusEnum = typeof ServingStatusEnum[keyof typeof ServingStatusEnum];

/**
 * 
 * @export
 * @interface TenanciesResponseWrapper
 */
export interface TenanciesResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof TenanciesResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<TenancyResponse>}
     * @memberof TenanciesResponseWrapper
     */
    'data'?: Array<TenancyResponse>;
}
/**
 * A request to patch a tenancy filter.
 * @export
 * @interface TenancyFilterPatch
 */
export interface TenancyFilterPatch {
    /**
     * 
     * @type {number}
     * @memberof TenancyFilterPatch
     */
    'price_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterPatch
     */
    'status'?: TenancyFilterPatchStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterPatch
     */
    'line_item_id'?: string | null;
    /**
     * Categories allowed by this tenancy filter.
     * @type {Array<Category>}
     * @memberof TenancyFilterPatch
     */
    'categories'?: Array<Category> | null;
    /**
     * 
     * @type {any}
     * @memberof TenancyFilterPatch
     */
    'custom'?: any;
}

export const TenancyFilterPatchStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type TenancyFilterPatchStatusEnum = typeof TenancyFilterPatchStatusEnum[keyof typeof TenancyFilterPatchStatusEnum];

/**
 * A request to create a tenancy filter.
 * @export
 * @interface TenancyFilterRequest
 */
export interface TenancyFilterRequest {
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterRequest
     */
    'tenancy_id': string;
    /**
     * 
     * @type {number}
     * @memberof TenancyFilterRequest
     */
    'price_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterRequest
     */
    'line_item_id'?: string | null;
    /**
     * Categories allowed by this tenancy filter.
     * @type {Array<Category>}
     * @memberof TenancyFilterRequest
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {any}
     * @memberof TenancyFilterRequest
     */
    'custom'?: any;
}
/**
 * A tenancy filter response.
 * @export
 * @interface TenancyFilterResponse
 */
export interface TenancyFilterResponse {
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'id': string;
    /**
     * ID of the tenancy this filter is bound to. Can be used in the query string to filter by tenancy. 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'tenancy_id': string;
    /**
     * 
     * @type {number}
     * @memberof TenancyFilterResponse
     */
    'price_cents'?: number | null;
    /**
     * The status of the tenancy filter. Can be used in the filter query string. Multiple choice filter is allowed.
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'status': TenancyFilterResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'line_item_id'?: string | null;
    /**
     * Categories allowed by this tenancy filter. If none of them is specified in the ad set input, the campaign will not be eligible for bidding. Can be used in the filter query string. The filter restriction should filter by category key. 
     * @type {Array<Category>}
     * @memberof TenancyFilterResponse
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {any}
     * @memberof TenancyFilterResponse
     */
    'custom'?: any;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'billed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterResponse
     */
    'updated_at': string;
}

export const TenancyFilterResponseStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type TenancyFilterResponseStatusEnum = typeof TenancyFilterResponseStatusEnum[keyof typeof TenancyFilterResponseStatusEnum];

/**
 * 
 * @export
 * @interface TenancyFilterResponseWrapper
 */
export interface TenancyFilterResponseWrapper {
    /**
     * 
     * @type {TenancyFilterResponse}
     * @memberof TenancyFilterResponseWrapper
     */
    'data'?: TenancyFilterResponse;
}
/**
 * A request to update a tenancy filter.
 * @export
 * @interface TenancyFilterUpdate
 */
export interface TenancyFilterUpdate {
    /**
     * 
     * @type {number}
     * @memberof TenancyFilterUpdate
     */
    'price_cents': number | null;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterUpdate
     */
    'status': TenancyFilterUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TenancyFilterUpdate
     */
    'line_item_id': string | null;
    /**
     * Categories allowed by this tenancy filter.
     * @type {Array<Category>}
     * @memberof TenancyFilterUpdate
     */
    'categories': Array<Category>;
    /**
     * 
     * @type {any}
     * @memberof TenancyFilterUpdate
     */
    'custom'?: any;
}

export const TenancyFilterUpdateStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type TenancyFilterUpdateStatusEnum = typeof TenancyFilterUpdateStatusEnum[keyof typeof TenancyFilterUpdateStatusEnum];

/**
 * A request to upsert tenancy filters. Use this to create or update multiple tenancy filters in a single request. 
 * @export
 * @interface TenancyFiltersRequest
 */
export interface TenancyFiltersRequest {
    /**
     * 
     * @type {Array<TenancyFilterRequest>}
     * @memberof TenancyFiltersRequest
     */
    'tenancy_filters': Array<TenancyFilterRequest>;
}
/**
 * 
 * @export
 * @interface TenancyFiltersResponseWrapper
 */
export interface TenancyFiltersResponseWrapper {
    /**
     * 
     * @type {PageInfoResponse}
     * @memberof TenancyFiltersResponseWrapper
     */
    'page_info'?: PageInfoResponse;
    /**
     * 
     * @type {Array<TenancyFilterResponse>}
     * @memberof TenancyFiltersResponseWrapper
     */
    'data'?: Array<TenancyFilterResponse>;
}
/**
 * A request to patch (partially update) an existing tenancy. Use this to modify specific properties of a tenancy without requiring all fields. 
 * @export
 * @interface TenancyPatch
 */
export interface TenancyPatch {
    /**
     * The updated name of the tenancy.
     * @type {string}
     * @memberof TenancyPatch
     */
    'name'?: string | null;
    /**
     * The updated start date of the tenancy. The system will trigger it at the end of the day (23:59:59), UTC timezone. 
     * @type {string}
     * @memberof TenancyPatch
     */
    'start'?: string | null;
    /**
     * The updated end date of the tenancy. The system will trigger it at the end of the day (23:59:59), UTC timezone. 
     * @type {string}
     * @memberof TenancyPatch
     */
    'end'?: string | null;
    /**
     * The updated slot position of the tenancy.
     * @type {number}
     * @memberof TenancyPatch
     */
    'position'?: number | null;
    /**
     * The updated status of the tenancy.
     * @type {string}
     * @memberof TenancyPatch
     */
    'status'?: TenancyPatchStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof TenancyPatch
     */
    'custom'?: any;
}

export const TenancyPatchStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type TenancyPatchStatusEnum = typeof TenancyPatchStatusEnum[keyof typeof TenancyPatchStatusEnum];

/**
 * A request to create a tenancy.
 * @export
 * @interface TenancyRequest
 */
export interface TenancyRequest {
    /**
     * The ID of the placement associated with the tenancy.
     * @type {string}
     * @memberof TenancyRequest
     */
    'placement_id': string;
    /**
     * The name of the new tenancy.
     * @type {string}
     * @memberof TenancyRequest
     */
    'name'?: string;
    /**
     * The start date of the tenancy. The system will trigger it at the beginning of the day (00:00:00), UTC timezone. 
     * @type {string}
     * @memberof TenancyRequest
     */
    'start': string;
    /**
     * The end date of the tenancy. The system will trigger it at the end of the day (23:59:59), UTC timezone. 
     * @type {string}
     * @memberof TenancyRequest
     */
    'end': string;
    /**
     * The position of the tenancy.
     * @type {number}
     * @memberof TenancyRequest
     */
    'position': number;
    /**
     * 
     * @type {any}
     * @memberof TenancyRequest
     */
    'custom'?: any;
}
/**
 * A response containing details about a tenancy. Use this to retrieve information about an existing tenancy. 
 * @export
 * @interface TenancyResponse
 */
export interface TenancyResponse {
    /**
     * The unique identifier for the tenancy.
     * @type {string}
     * @memberof TenancyResponse
     */
    'id': string;
    /**
     * The ID of the placement to which this tenancy is bound. Can be used in the query string to filter by placement. 
     * @type {string}
     * @memberof TenancyResponse
     */
    'placement_id': string;
    /**
     * The name of the tenancy.
     * @type {string}
     * @memberof TenancyResponse
     */
    'name': string | null;
    /**
     * The start date of the tenancy. The system will trigger it at the beginning of the day (00:00:00), UTC timezone. Can be used in the filter query string. 
     * @type {string}
     * @memberof TenancyResponse
     */
    'start': string;
    /**
     * The end date of the tenancy. The system will trigger it at the end of the day (23:59:59), UTC timezone. Can be used in the filter query string. 
     * @type {string}
     * @memberof TenancyResponse
     */
    'end': string;
    /**
     * The slot position of the tenancy. Can be used in the filter query string. 
     * @type {number}
     * @memberof TenancyResponse
     */
    'position': number;
    /**
     * The status of the tenancy.
     * @type {string}
     * @memberof TenancyResponse
     */
    'status': TenancyResponseStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof TenancyResponse
     */
    'custom'?: any;
    /**
     * The timestamp when the tenancy was created.
     * @type {string}
     * @memberof TenancyResponse
     */
    'created_at': string;
    /**
     * The timestamp when the tenancy was last updated.
     * @type {string}
     * @memberof TenancyResponse
     */
    'updated_at': string;
}

export const TenancyResponseStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;

export type TenancyResponseStatusEnum = typeof TenancyResponseStatusEnum[keyof typeof TenancyResponseStatusEnum];

/**
 * 
 * @export
 * @interface TenancyResponseWrapper
 */
export interface TenancyResponseWrapper {
    /**
     * 
     * @type {TenancyResponse}
     * @memberof TenancyResponseWrapper
     */
    'data'?: TenancyResponse;
}
/**
 * A request to update an existing tenancy. Use this to modify specific properties of a tenancy. 
 * @export
 * @interface TenancyUpdate
 */
export interface TenancyUpdate {
    /**
     * The updated name of the tenancy.
     * @type {string}
     * @memberof TenancyUpdate
     */
    'name': string;
    /**
     * The updated start date of the tenancy. The system will trigger it at the beginning of the day (00:00:00), UTC timezone. 
     * @type {string}
     * @memberof TenancyUpdate
     */
    'start': string;
    /**
     * The updated end date of the tenancy. The system will trigger it at the end of the day (23:59:59), UTC timezone. 
     * @type {string}
     * @memberof TenancyUpdate
     */
    'end': string;
    /**
     * The updated slot position of the tenancy.
     * @type {number}
     * @memberof TenancyUpdate
     */
    'position': number;
    /**
     * The updated status of the tenancy.
     * @type {string}
     * @memberof TenancyUpdate
     */
    'status': TenancyUpdateStatusEnum;
    /**
     * 
     * @type {any}
     * @memberof TenancyUpdate
     */
    'custom'?: any;
}

export const TenancyUpdateStatusEnum = {
    Draft: 'DRAFT',
    Inactive: 'INACTIVE',
    Active: 'ACTIVE'
} as const;

export type TenancyUpdateStatusEnum = typeof TenancyUpdateStatusEnum[keyof typeof TenancyUpdateStatusEnum];

/**
 * `VOLUME` commitment delivers a fixed number of billable events. Supported billing type is `CPM`. 
 * @export
 * @interface VolumeCommitment
 */
export interface VolumeCommitment {
    /**
     * 
     * @type {string}
     * @memberof VolumeCommitment
     */
    'type': VolumeCommitmentTypeEnum;
    /**
     * Value represents the total number of billable events. Supported billing type is `CPM`. The remaining budget must cover the remaining volume at a minimum rate of 0.01 cost per mile. Once the value is fulfilled, the line item\'s total budget can no longer be updated unless the commitment value is updated too. If these requirements are not met, the request will fail with a validation error. 
     * @type {number}
     * @memberof VolumeCommitment
     */
    'value': number;
    /**
     * Position in the ad set.
     * @type {number}
     * @memberof VolumeCommitment
     */
    'position'?: number | null;
}

export const VolumeCommitmentTypeEnum = {
    Volume: 'VOLUME'
} as const;

export type VolumeCommitmentTypeEnum = typeof VolumeCommitmentTypeEnum[keyof typeof VolumeCommitmentTypeEnum];


/**
 * CampaignsApi - axios parameter creator
 * @export
 */
export const CampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive a Campaign. Campaigns are never permanently deleted.
         * @summary Archive campaign
         * @param {string} campaignId ID of the Campaign to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCampaign: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('archiveCampaign', 'campaignId', campaignId)
            const localVarPath = `/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a campaign.
         * @summary Create a campaign
         * @param {CampaignRequest} campaignRequest Request body for creating a new campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (campaignRequest: CampaignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignRequest' is not null or undefined
            assertParamExists('createCampaign', 'campaignRequest', campaignRequest)
            const localVarPath = `/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a campaign.
         * @summary Get campaign
         * @param {string} campaignId ID of the Campaign to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (campaignId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaign', 'campaignId', campaignId)
            const localVarPath = `/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:campaign", "read:campaign"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of Campaigns available to the user.
         * @summary List campaigns
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;  Available fields: - &#x60;id&#x60;: Campaign ID, - &#x60;name&#x60;: Campaign name, - &#x60;advertiser_id&#x60;: Campaign advertiser ID, - &#x60;budget_total_cents&#x60;: Campaign total budget in cents, - &#x60;budget_total_left_cents&#x60;: Campaign total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Campaign Total budget left as percentage of the total budget, - &#x60;status&#x60;: Campaign status, - &#x60;active_from&#x60;: Campaign active from date, - &#x60;active_to&#x60;: Campaign active to date, - &#x60;line_item.placement_id&#x60;: Campaign\&#39;s line items placement ID, - &#x60;line_item.target_category_key&#x60;: Campaign\&#39;s line items targeted category keys, - &#x60;line_item.product_category_key&#x60;: Campaign\&#39;s line items advertised products category keys, - &#x60;line_item.product_brand&#x60;: Campaign\&#39;s line items advertised products brands, and - &#x60;tenancy.id&#x60;: Campaign\&#39;s line items tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns: async (filter?: string, orderBy?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:campaign", "read:campaign"], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of available retailer tags for campaigns.
         * @summary List campaigns retailer tags
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaignsRetailerTags: async (limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/campaigns/retailer-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:campaign"], configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific field(s) of a Campaign.
         * @summary Update campaign
         * @param {string} campaignId ID of Campaign to partially update
         * @param {CampaignPatch} campaignPatch Request body for updating status/attributes of an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaign: async (campaignId: string, campaignPatch: CampaignPatch, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('patchCampaign', 'campaignId', campaignId)
            // verify required parameter 'campaignPatch' is not null or undefined
            assertParamExists('patchCampaign', 'campaignPatch', campaignPatch)
            const localVarPath = `/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update details of a specific Campaign. Complete object must be provided.
         * @summary Update campaign
         * @param {string} campaignId ID of the Campaign to update
         * @param {CampaignUpdate} campaignUpdate Request body for updating an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign: async (campaignId: string, campaignUpdate: CampaignUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updateCampaign', 'campaignId', campaignId)
            // verify required parameter 'campaignUpdate' is not null or undefined
            assertParamExists('updateCampaign', 'campaignUpdate', campaignUpdate)
            const localVarPath = `/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(campaignUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignsApi - functional programming interface
 * @export
 */
export const CampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive a Campaign. Campaigns are never permanently deleted.
         * @summary Archive campaign
         * @param {string} campaignId ID of the Campaign to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveCampaign(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveCampaign(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a campaign.
         * @summary Create a campaign
         * @param {CampaignRequest} campaignRequest Request body for creating a new campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(campaignRequest: CampaignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCampaign(campaignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a campaign.
         * @summary Get campaign
         * @param {string} campaignId ID of the Campaign to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(campaignId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaign(campaignId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of Campaigns available to the user.
         * @summary List campaigns
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;  Available fields: - &#x60;id&#x60;: Campaign ID, - &#x60;name&#x60;: Campaign name, - &#x60;advertiser_id&#x60;: Campaign advertiser ID, - &#x60;budget_total_cents&#x60;: Campaign total budget in cents, - &#x60;budget_total_left_cents&#x60;: Campaign total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Campaign Total budget left as percentage of the total budget, - &#x60;status&#x60;: Campaign status, - &#x60;active_from&#x60;: Campaign active from date, - &#x60;active_to&#x60;: Campaign active to date, - &#x60;line_item.placement_id&#x60;: Campaign\&#39;s line items placement ID, - &#x60;line_item.target_category_key&#x60;: Campaign\&#39;s line items targeted category keys, - &#x60;line_item.product_category_key&#x60;: Campaign\&#39;s line items advertised products category keys, - &#x60;line_item.product_brand&#x60;: Campaign\&#39;s line items advertised products brands, and - &#x60;tenancy.id&#x60;: Campaign\&#39;s line items tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCampaigns(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaigns(filter, orderBy, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of available retailer tags for campaigns.
         * @summary List campaigns retailer tags
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCampaignsRetailerTags(limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignsRetailerTagsResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaignsRetailerTags(limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update specific field(s) of a Campaign.
         * @summary Update campaign
         * @param {string} campaignId ID of Campaign to partially update
         * @param {CampaignPatch} campaignPatch Request body for updating status/attributes of an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCampaign(campaignId: string, campaignPatch: CampaignPatch, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCampaign(campaignId, campaignPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update details of a specific Campaign. Complete object must be provided.
         * @summary Update campaign
         * @param {string} campaignId ID of the Campaign to update
         * @param {CampaignUpdate} campaignUpdate Request body for updating an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCampaign(campaignId: string, campaignUpdate: CampaignUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCampaign(campaignId, campaignUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CampaignsApi - factory interface
 * @export
 */
export const CampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignsApiFp(configuration)
    return {
        /**
         * Archive a Campaign. Campaigns are never permanently deleted.
         * @summary Archive campaign
         * @param {string} campaignId ID of the Campaign to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveCampaign(campaignId: string, options?: any): AxiosPromise<void> {
            return localVarFp.archiveCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a campaign.
         * @summary Create a campaign
         * @param {CampaignRequest} campaignRequest Request body for creating a new campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(campaignRequest: CampaignRequest, options?: any): AxiosPromise<CampaignResponseWrapper> {
            return localVarFp.createCampaign(campaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a campaign.
         * @summary Get campaign
         * @param {string} campaignId ID of the Campaign to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(campaignId: string, options?: any): AxiosPromise<CampaignResponseWrapper> {
            return localVarFp.getCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of Campaigns available to the user.
         * @summary List campaigns
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;  Available fields: - &#x60;id&#x60;: Campaign ID, - &#x60;name&#x60;: Campaign name, - &#x60;advertiser_id&#x60;: Campaign advertiser ID, - &#x60;budget_total_cents&#x60;: Campaign total budget in cents, - &#x60;budget_total_left_cents&#x60;: Campaign total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Campaign Total budget left as percentage of the total budget, - &#x60;status&#x60;: Campaign status, - &#x60;active_from&#x60;: Campaign active from date, - &#x60;active_to&#x60;: Campaign active to date, - &#x60;line_item.placement_id&#x60;: Campaign\&#39;s line items placement ID, - &#x60;line_item.target_category_key&#x60;: Campaign\&#39;s line items targeted category keys, - &#x60;line_item.product_category_key&#x60;: Campaign\&#39;s line items advertised products category keys, - &#x60;line_item.product_brand&#x60;: Campaign\&#39;s line items advertised products brands, and - &#x60;tenancy.id&#x60;: Campaign\&#39;s line items tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<CampaignsResponseWrapper> {
            return localVarFp.listCampaigns(filter, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of available retailer tags for campaigns.
         * @summary List campaigns retailer tags
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaignsRetailerTags(limit?: number, cursor?: string, options?: any): AxiosPromise<CampaignsRetailerTagsResponseWrapper> {
            return localVarFp.listCampaignsRetailerTags(limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific field(s) of a Campaign.
         * @summary Update campaign
         * @param {string} campaignId ID of Campaign to partially update
         * @param {CampaignPatch} campaignPatch Request body for updating status/attributes of an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCampaign(campaignId: string, campaignPatch: CampaignPatch, options?: any): AxiosPromise<void> {
            return localVarFp.patchCampaign(campaignId, campaignPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update details of a specific Campaign. Complete object must be provided.
         * @summary Update campaign
         * @param {string} campaignId ID of the Campaign to update
         * @param {CampaignUpdate} campaignUpdate Request body for updating an existing campaign.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign(campaignId: string, campaignUpdate: CampaignUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateCampaign(campaignId, campaignUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignsApi - object-oriented interface
 * @export
 * @class CampaignsApi
 * @extends {BaseAPI}
 */
export class CampaignsApi extends BaseAPI {
    /**
     * Archive a Campaign. Campaigns are never permanently deleted.
     * @summary Archive campaign
     * @param {string} campaignId ID of the Campaign to archive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public archiveCampaign(campaignId: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).archiveCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a campaign.
     * @summary Create a campaign
     * @param {CampaignRequest} campaignRequest Request body for creating a new campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public createCampaign(campaignRequest: CampaignRequest, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).createCampaign(campaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a campaign.
     * @summary Get campaign
     * @param {string} campaignId ID of the Campaign to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public getCampaign(campaignId: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).getCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of Campaigns available to the user.
     * @summary List campaigns
     * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;  Available fields: - &#x60;id&#x60;: Campaign ID, - &#x60;name&#x60;: Campaign name, - &#x60;advertiser_id&#x60;: Campaign advertiser ID, - &#x60;budget_total_cents&#x60;: Campaign total budget in cents, - &#x60;budget_total_left_cents&#x60;: Campaign total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Campaign Total budget left as percentage of the total budget, - &#x60;status&#x60;: Campaign status, - &#x60;active_from&#x60;: Campaign active from date, - &#x60;active_to&#x60;: Campaign active to date, - &#x60;line_item.placement_id&#x60;: Campaign\&#39;s line items placement ID, - &#x60;line_item.target_category_key&#x60;: Campaign\&#39;s line items targeted category keys, - &#x60;line_item.product_category_key&#x60;: Campaign\&#39;s line items advertised products category keys, - &#x60;line_item.product_brand&#x60;: Campaign\&#39;s line items advertised products brands, and - &#x60;tenancy.id&#x60;: Campaign\&#39;s line items tenancy ID. 
     * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public listCampaigns(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).listCampaigns(filter, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of available retailer tags for campaigns.
     * @summary List campaigns retailer tags
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public listCampaignsRetailerTags(limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).listCampaignsRetailerTags(limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific field(s) of a Campaign.
     * @summary Update campaign
     * @param {string} campaignId ID of Campaign to partially update
     * @param {CampaignPatch} campaignPatch Request body for updating status/attributes of an existing campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public patchCampaign(campaignId: string, campaignPatch: CampaignPatch, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).patchCampaign(campaignId, campaignPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update details of a specific Campaign. Complete object must be provided.
     * @summary Update campaign
     * @param {string} campaignId ID of the Campaign to update
     * @param {CampaignUpdate} campaignUpdate Request body for updating an existing campaign.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignsApi
     */
    public updateCampaign(campaignId: string, campaignUpdate: CampaignUpdate, options?: AxiosRequestConfig) {
        return CampaignsApiFp(this.configuration).updateCampaign(campaignId, campaignUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LineItemsApi - axios parameter creator
 * @export
 */
export const LineItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive an Line Item. Line Items are never permanently deleted.
         * @summary Archive line item
         * @param {string} lineItemId ID of the Line Item to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveLineItem: async (lineItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('archiveLineItem', 'lineItemId', lineItemId)
            const localVarPath = `/line-items/{line_item_id}`
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a line item.
         * @summary Create a line item
         * @param {LineItemRequest} lineItemRequest Request body for creating a new line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLineItem: async (lineItemRequest: LineItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemRequest' is not null or undefined
            assertParamExists('createLineItem', 'lineItemRequest', lineItemRequest)
            const localVarPath = `/line-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lineItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete pending changes of a line item.
         * @summary Delete line item pending changes
         * @param {string} lineItemId ID of the Line Item to delete pending changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineItemPendingChanges: async (lineItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('deleteLineItemPendingChanges', 'lineItemId', lineItemId)
            const localVarPath = `/line-items/{line_item_id}/pending-changes`
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a line item.
         * @summary Get line item
         * @param {string} lineItemId ID of the Line Item to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItem: async (lineItemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('getLineItem', 'lineItemId', lineItemId)
            const localVarPath = `/line-items/{line_item_id}`
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:campaign", "read:campaign"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of Line Items available to the user.
         * @summary List line items
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;   Available fields: - &#x60;id&#x60;: Line Item ID, - &#x60;name&#x60;: Line Item name, - &#x60;placement_id&#x60;: Line Item placement ID, - &#x60;campaign_id&#x60;: Line Item campaign ID, - &#x60;tenancy_filter_id&#x60;: Line Item tenancy filter ID, - &#x60;advertised_skus&#x60;: Line Item advertised SKUs, - &#x60;audience_id&#x60;: Line Item audience ID, - &#x60;bid_cents&#x60;: Line Item bid in cents, - &#x60;budget_total_cents&#x60;: Line Item total budget in cents, - &#x60;budget_total_left_cents&#x60;: Line Item total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Line Item Total budget left as percentage of the total budget, - &#x60;advertised_status&#x60;: Line Item advertised status, - &#x60;retailer_status&#x60;: Line Item retailer status, - &#x60;retailer_approval&#x60;: Line Item retailer approval, - &#x60;serving.status&#x60;: Line Item serving status (SERVING, NOT_SERVING), - &#x60;target_category_key&#x60;: Line item targeted category keys, - &#x60;product_category_key&#x60;: Line Item advertised products category keys, - &#x60;product_brand&#x60;: Line Item advertised products brands, - &#x60;delivery_mode&#x60;: Line Item delivery mode (AUCTION, GUARANTEED, HOUSE_AD), - &#x60;commitment.position&#x60;: Line Item commitment position in the ad set, - &#x60;campaign.advertiser_id&#x60;: Line Item campaign advertiser ID, - &#x60;campaign.active_from&#x60;: Line Item campaign start date (campaigns without a start date always match), - &#x60;campaign.active_to&#x60;: Line Item campaign end date (campaigns without an end date always match), and - &#x60;tenancy.id&#x60;: Line Item tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLineItems: async (filter?: string, orderBy?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/line-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:campaign", "read:campaign"], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific field(s) of an Line Item.
         * @summary Update line item
         * @param {string} lineItemId ID of Line Item to partially update
         * @param {LineItemPatch} lineItemPatch Request body for updating status/attributes of an existing line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLineItem: async (lineItemId: string, lineItemPatch: LineItemPatch, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('patchLineItem', 'lineItemId', lineItemId)
            // verify required parameter 'lineItemPatch' is not null or undefined
            assertParamExists('patchLineItem', 'lineItemPatch', lineItemPatch)
            const localVarPath = `/line-items/{line_item_id}`
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lineItemPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update details of a specific Line Item. Complete object must be provided.
         * @summary Update line item
         * @param {string} lineItemId ID of the Line Item to update
         * @param {LineItemUpdate} lineItemUpdate Request body for updating an existing LineItem.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineItem: async (lineItemId: string, lineItemUpdate: LineItemUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('updateLineItem', 'lineItemId', lineItemId)
            // verify required parameter 'lineItemUpdate' is not null or undefined
            assertParamExists('updateLineItem', 'lineItemUpdate', lineItemUpdate)
            const localVarPath = `/line-items/{line_item_id}`
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:campaign", "write:campaign"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lineItemUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineItemsApi - functional programming interface
 * @export
 */
export const LineItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive an Line Item. Line Items are never permanently deleted.
         * @summary Archive line item
         * @param {string} lineItemId ID of the Line Item to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveLineItem(lineItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveLineItem(lineItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a line item.
         * @summary Create a line item
         * @param {LineItemRequest} lineItemRequest Request body for creating a new line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLineItem(lineItemRequest: LineItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineItemResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLineItem(lineItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete pending changes of a line item.
         * @summary Delete line item pending changes
         * @param {string} lineItemId ID of the Line Item to delete pending changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLineItemPendingChanges(lineItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLineItemPendingChanges(lineItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a line item.
         * @summary Get line item
         * @param {string} lineItemId ID of the Line Item to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineItem(lineItemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineItemResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineItem(lineItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of Line Items available to the user.
         * @summary List line items
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;   Available fields: - &#x60;id&#x60;: Line Item ID, - &#x60;name&#x60;: Line Item name, - &#x60;placement_id&#x60;: Line Item placement ID, - &#x60;campaign_id&#x60;: Line Item campaign ID, - &#x60;tenancy_filter_id&#x60;: Line Item tenancy filter ID, - &#x60;advertised_skus&#x60;: Line Item advertised SKUs, - &#x60;audience_id&#x60;: Line Item audience ID, - &#x60;bid_cents&#x60;: Line Item bid in cents, - &#x60;budget_total_cents&#x60;: Line Item total budget in cents, - &#x60;budget_total_left_cents&#x60;: Line Item total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Line Item Total budget left as percentage of the total budget, - &#x60;advertised_status&#x60;: Line Item advertised status, - &#x60;retailer_status&#x60;: Line Item retailer status, - &#x60;retailer_approval&#x60;: Line Item retailer approval, - &#x60;serving.status&#x60;: Line Item serving status (SERVING, NOT_SERVING), - &#x60;target_category_key&#x60;: Line item targeted category keys, - &#x60;product_category_key&#x60;: Line Item advertised products category keys, - &#x60;product_brand&#x60;: Line Item advertised products brands, - &#x60;delivery_mode&#x60;: Line Item delivery mode (AUCTION, GUARANTEED, HOUSE_AD), - &#x60;commitment.position&#x60;: Line Item commitment position in the ad set, - &#x60;campaign.advertiser_id&#x60;: Line Item campaign advertiser ID, - &#x60;campaign.active_from&#x60;: Line Item campaign start date (campaigns without a start date always match), - &#x60;campaign.active_to&#x60;: Line Item campaign end date (campaigns without an end date always match), and - &#x60;tenancy.id&#x60;: Line Item tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLineItems(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineItemsResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLineItems(filter, orderBy, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update specific field(s) of an Line Item.
         * @summary Update line item
         * @param {string} lineItemId ID of Line Item to partially update
         * @param {LineItemPatch} lineItemPatch Request body for updating status/attributes of an existing line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLineItem(lineItemId: string, lineItemPatch: LineItemPatch, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLineItem(lineItemId, lineItemPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update details of a specific Line Item. Complete object must be provided.
         * @summary Update line item
         * @param {string} lineItemId ID of the Line Item to update
         * @param {LineItemUpdate} lineItemUpdate Request body for updating an existing LineItem.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLineItem(lineItemId: string, lineItemUpdate: LineItemUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLineItem(lineItemId, lineItemUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LineItemsApi - factory interface
 * @export
 */
export const LineItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineItemsApiFp(configuration)
    return {
        /**
         * Archive an Line Item. Line Items are never permanently deleted.
         * @summary Archive line item
         * @param {string} lineItemId ID of the Line Item to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveLineItem(lineItemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.archiveLineItem(lineItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a line item.
         * @summary Create a line item
         * @param {LineItemRequest} lineItemRequest Request body for creating a new line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLineItem(lineItemRequest: LineItemRequest, options?: any): AxiosPromise<LineItemResponseWrapper> {
            return localVarFp.createLineItem(lineItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete pending changes of a line item.
         * @summary Delete line item pending changes
         * @param {string} lineItemId ID of the Line Item to delete pending changes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLineItemPendingChanges(lineItemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLineItemPendingChanges(lineItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a line item.
         * @summary Get line item
         * @param {string} lineItemId ID of the Line Item to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItem(lineItemId: string, options?: any): AxiosPromise<LineItemResponseWrapper> {
            return localVarFp.getLineItem(lineItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of Line Items available to the user.
         * @summary List line items
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;   Available fields: - &#x60;id&#x60;: Line Item ID, - &#x60;name&#x60;: Line Item name, - &#x60;placement_id&#x60;: Line Item placement ID, - &#x60;campaign_id&#x60;: Line Item campaign ID, - &#x60;tenancy_filter_id&#x60;: Line Item tenancy filter ID, - &#x60;advertised_skus&#x60;: Line Item advertised SKUs, - &#x60;audience_id&#x60;: Line Item audience ID, - &#x60;bid_cents&#x60;: Line Item bid in cents, - &#x60;budget_total_cents&#x60;: Line Item total budget in cents, - &#x60;budget_total_left_cents&#x60;: Line Item total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Line Item Total budget left as percentage of the total budget, - &#x60;advertised_status&#x60;: Line Item advertised status, - &#x60;retailer_status&#x60;: Line Item retailer status, - &#x60;retailer_approval&#x60;: Line Item retailer approval, - &#x60;serving.status&#x60;: Line Item serving status (SERVING, NOT_SERVING), - &#x60;target_category_key&#x60;: Line item targeted category keys, - &#x60;product_category_key&#x60;: Line Item advertised products category keys, - &#x60;product_brand&#x60;: Line Item advertised products brands, - &#x60;delivery_mode&#x60;: Line Item delivery mode (AUCTION, GUARANTEED, HOUSE_AD), - &#x60;commitment.position&#x60;: Line Item commitment position in the ad set, - &#x60;campaign.advertiser_id&#x60;: Line Item campaign advertiser ID, - &#x60;campaign.active_from&#x60;: Line Item campaign start date (campaigns without a start date always match), - &#x60;campaign.active_to&#x60;: Line Item campaign end date (campaigns without an end date always match), and - &#x60;tenancy.id&#x60;: Line Item tenancy ID. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLineItems(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<LineItemsResponseWrapper> {
            return localVarFp.listLineItems(filter, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific field(s) of an Line Item.
         * @summary Update line item
         * @param {string} lineItemId ID of Line Item to partially update
         * @param {LineItemPatch} lineItemPatch Request body for updating status/attributes of an existing line item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLineItem(lineItemId: string, lineItemPatch: LineItemPatch, options?: any): AxiosPromise<void> {
            return localVarFp.patchLineItem(lineItemId, lineItemPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update details of a specific Line Item. Complete object must be provided.
         * @summary Update line item
         * @param {string} lineItemId ID of the Line Item to update
         * @param {LineItemUpdate} lineItemUpdate Request body for updating an existing LineItem.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineItem(lineItemId: string, lineItemUpdate: LineItemUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateLineItem(lineItemId, lineItemUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineItemsApi - object-oriented interface
 * @export
 * @class LineItemsApi
 * @extends {BaseAPI}
 */
export class LineItemsApi extends BaseAPI {
    /**
     * Archive an Line Item. Line Items are never permanently deleted.
     * @summary Archive line item
     * @param {string} lineItemId ID of the Line Item to archive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public archiveLineItem(lineItemId: string, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).archiveLineItem(lineItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a line item.
     * @summary Create a line item
     * @param {LineItemRequest} lineItemRequest Request body for creating a new line item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public createLineItem(lineItemRequest: LineItemRequest, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).createLineItem(lineItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete pending changes of a line item.
     * @summary Delete line item pending changes
     * @param {string} lineItemId ID of the Line Item to delete pending changes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public deleteLineItemPendingChanges(lineItemId: string, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).deleteLineItemPendingChanges(lineItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a line item.
     * @summary Get line item
     * @param {string} lineItemId ID of the Line Item to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public getLineItem(lineItemId: string, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).getLineItem(lineItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of Line Items available to the user.
     * @summary List line items
     * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;   Available fields: - &#x60;id&#x60;: Line Item ID, - &#x60;name&#x60;: Line Item name, - &#x60;placement_id&#x60;: Line Item placement ID, - &#x60;campaign_id&#x60;: Line Item campaign ID, - &#x60;tenancy_filter_id&#x60;: Line Item tenancy filter ID, - &#x60;advertised_skus&#x60;: Line Item advertised SKUs, - &#x60;audience_id&#x60;: Line Item audience ID, - &#x60;bid_cents&#x60;: Line Item bid in cents, - &#x60;budget_total_cents&#x60;: Line Item total budget in cents, - &#x60;budget_total_left_cents&#x60;: Line Item total budget left in cents, - &#x60;budget_total_left_percent&#x60;: Line Item Total budget left as percentage of the total budget, - &#x60;advertised_status&#x60;: Line Item advertised status, - &#x60;retailer_status&#x60;: Line Item retailer status, - &#x60;retailer_approval&#x60;: Line Item retailer approval, - &#x60;serving.status&#x60;: Line Item serving status (SERVING, NOT_SERVING), - &#x60;target_category_key&#x60;: Line item targeted category keys, - &#x60;product_category_key&#x60;: Line Item advertised products category keys, - &#x60;product_brand&#x60;: Line Item advertised products brands, - &#x60;delivery_mode&#x60;: Line Item delivery mode (AUCTION, GUARANTEED, HOUSE_AD), - &#x60;commitment.position&#x60;: Line Item commitment position in the ad set, - &#x60;campaign.advertiser_id&#x60;: Line Item campaign advertiser ID, - &#x60;campaign.active_from&#x60;: Line Item campaign start date (campaigns without a start date always match), - &#x60;campaign.active_to&#x60;: Line Item campaign end date (campaigns without an end date always match), and - &#x60;tenancy.id&#x60;: Line Item tenancy ID. 
     * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public listLineItems(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).listLineItems(filter, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific field(s) of an Line Item.
     * @summary Update line item
     * @param {string} lineItemId ID of Line Item to partially update
     * @param {LineItemPatch} lineItemPatch Request body for updating status/attributes of an existing line item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public patchLineItem(lineItemId: string, lineItemPatch: LineItemPatch, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).patchLineItem(lineItemId, lineItemPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update details of a specific Line Item. Complete object must be provided.
     * @summary Update line item
     * @param {string} lineItemId ID of the Line Item to update
     * @param {LineItemUpdate} lineItemUpdate Request body for updating an existing LineItem.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineItemsApi
     */
    public updateLineItem(lineItemId: string, lineItemUpdate: LineItemUpdate, options?: AxiosRequestConfig) {
        return LineItemsApiFp(this.configuration).updateLineItem(lineItemId, lineItemUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlacementsApi - axios parameter creator
 * @export
 */
export const PlacementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive a Placement. Placements are never permanently deleted.
         * @summary Archive placement
         * @param {string} placementId ID of the Placement to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePlacement: async (placementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('archivePlacement', 'placementId', placementId)
            const localVarPath = `/placements/{placement_id}`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:placement"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a placement. 
         * @summary Create a placement
         * @param {PlacementRequest} placementRequest Request body for creating a new placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlacement: async (placementRequest: PlacementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementRequest' is not null or undefined
            assertParamExists('createPlacement', 'placementRequest', placementRequest)
            const localVarPath = `/placements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:placement"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the minimum required bid in cents for a placement, based on the desired billing type and target categories. 
         * @summary Calculate minimum required bid for a placement
         * @param {string} placementId ID of the Placement
         * @param {PlacementMinBidRequest} placementMinBidRequest Request body for retrieving the minimum required bid for a placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinBid: async (placementId: string, placementMinBidRequest: PlacementMinBidRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('getMinBid', 'placementId', placementId)
            // verify required parameter 'placementMinBidRequest' is not null or undefined
            assertParamExists('getMinBid', 'placementMinBidRequest', placementMinBidRequest)
            const localVarPath = `/placements/{placement_id}/constraints/min-bid`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:placement", "read:placement"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementMinBidRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a placement.
         * @summary Get placement
         * @param {string} placementId ID of the Placement to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacement: async (placementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('getPlacement', 'placementId', placementId)
            const localVarPath = `/placements/{placement_id}`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:placement", "read:placement"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns keyword suggestions for the placement for provided products based on searches of last 30 days and with AI matching. 
         * @summary Get product keyword suggestions
         * @param {string} placementId ID of the Placement to add a keyword
         * @param {PlacementKeywordSuggestionRequest} placementKeywordSuggestionRequest Request body for retrieving keyword suggestions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementKeywordSuggestions: async (placementId: string, placementKeywordSuggestionRequest: PlacementKeywordSuggestionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('getPlacementKeywordSuggestions', 'placementId', placementId)
            // verify required parameter 'placementKeywordSuggestionRequest' is not null or undefined
            assertParamExists('getPlacementKeywordSuggestions', 'placementKeywordSuggestionRequest', placementKeywordSuggestionRequest)
            const localVarPath = `/placements/{placement_id}/keywords/suggestions`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:placement", "read:placement"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementKeywordSuggestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns distinct keywords associated with that placement, which have been used in the past 4 weeks at least 5 times to request ads in the Ad Service. The keywords are sorted by request frequency in descending order.
         * @summary List placement keywords
         * @param {string} placementId ID of the Placement to retrieve
         * @param {string} [q] The query for a search in the placements\&#39;s keywords. When using &#x60;q&#x60;, no other query parameters will be considered.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementKeywords: async (placementId: string, q?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('getPlacementKeywords', 'placementId', placementId)
            const localVarPath = `/placements/{placement_id}/keywords`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:placement", "read:placement"], configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of Placements available to the user.
         * @summary List placements
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;.   Available fields: - &#x60;id&#x60;: Placement ID, - &#x60;name&#x60;: Placement name, - &#x60;group&#x60;: Placement group, - &#x60;allowed_advertiser_ids&#x60;: Placement allowed advertiser IDs, and - &#x60;status&#x60;: Placement status. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlacements: async (filter?: string, orderBy?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/placements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:placement", "read:placement"], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific field(s) of a Placement.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of Placement to partially update
         * @param {PlacementPatchUpdate} placementPatchUpdate Request body for partially updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUpdatePlacement: async (placementId: string, placementPatchUpdate: PlacementPatchUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('patchUpdatePlacement', 'placementId', placementId)
            // verify required parameter 'placementPatchUpdate' is not null or undefined
            assertParamExists('patchUpdatePlacement', 'placementPatchUpdate', placementPatchUpdate)
            const localVarPath = `/placements/{placement_id}`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:placement"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementPatchUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update details of a specific Placement. Complete object must be provided.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of the Placement to update
         * @param {PlacementUpdate} placementUpdate Request body for updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlacement: async (placementId: string, placementUpdate: PlacementUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementId' is not null or undefined
            assertParamExists('updatePlacement', 'placementId', placementId)
            // verify required parameter 'placementUpdate' is not null or undefined
            assertParamExists('updatePlacement', 'placementUpdate', placementUpdate)
            const localVarPath = `/placements/{placement_id}`
                .replace(`{${"placement_id"}}`, encodeURIComponent(String(placementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:placement"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlacementsApi - functional programming interface
 * @export
 */
export const PlacementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlacementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive a Placement. Placements are never permanently deleted.
         * @summary Archive placement
         * @param {string} placementId ID of the Placement to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivePlacement(placementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivePlacement(placementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a placement. 
         * @summary Create a placement
         * @param {PlacementRequest} placementRequest Request body for creating a new placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlacement(placementRequest: PlacementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlacement(placementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the minimum required bid in cents for a placement, based on the desired billing type and target categories. 
         * @summary Calculate minimum required bid for a placement
         * @param {string} placementId ID of the Placement
         * @param {PlacementMinBidRequest} placementMinBidRequest Request body for retrieving the minimum required bid for a placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinBid(placementId: string, placementMinBidRequest: PlacementMinBidRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementMinBidResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinBid(placementId, placementMinBidRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a placement.
         * @summary Get placement
         * @param {string} placementId ID of the Placement to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacement(placementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacement(placementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns keyword suggestions for the placement for provided products based on searches of last 30 days and with AI matching. 
         * @summary Get product keyword suggestions
         * @param {string} placementId ID of the Placement to add a keyword
         * @param {PlacementKeywordSuggestionRequest} placementKeywordSuggestionRequest Request body for retrieving keyword suggestions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementKeywordSuggestions(placementId: string, placementKeywordSuggestionRequest: PlacementKeywordSuggestionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementKeywordSuggestionResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementKeywordSuggestions(placementId, placementKeywordSuggestionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns distinct keywords associated with that placement, which have been used in the past 4 weeks at least 5 times to request ads in the Ad Service. The keywords are sorted by request frequency in descending order.
         * @summary List placement keywords
         * @param {string} placementId ID of the Placement to retrieve
         * @param {string} [q] The query for a search in the placements\&#39;s keywords. When using &#x60;q&#x60;, no other query parameters will be considered.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlacementKeywords(placementId: string, q?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementKeywordsResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlacementKeywords(placementId, q, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of Placements available to the user.
         * @summary List placements
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;.   Available fields: - &#x60;id&#x60;: Placement ID, - &#x60;name&#x60;: Placement name, - &#x60;group&#x60;: Placement group, - &#x60;allowed_advertiser_ids&#x60;: Placement allowed advertiser IDs, and - &#x60;status&#x60;: Placement status. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlacements(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementsResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlacements(filter, orderBy, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update specific field(s) of a Placement.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of Placement to partially update
         * @param {PlacementPatchUpdate} placementPatchUpdate Request body for partially updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUpdatePlacement(placementId: string, placementPatchUpdate: PlacementPatchUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUpdatePlacement(placementId, placementPatchUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update details of a specific Placement. Complete object must be provided.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of the Placement to update
         * @param {PlacementUpdate} placementUpdate Request body for updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlacement(placementId: string, placementUpdate: PlacementUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlacement(placementId, placementUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlacementsApi - factory interface
 * @export
 */
export const PlacementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlacementsApiFp(configuration)
    return {
        /**
         * Archive a Placement. Placements are never permanently deleted.
         * @summary Archive placement
         * @param {string} placementId ID of the Placement to archive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivePlacement(placementId: string, options?: any): AxiosPromise<void> {
            return localVarFp.archivePlacement(placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a placement. 
         * @summary Create a placement
         * @param {PlacementRequest} placementRequest Request body for creating a new placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlacement(placementRequest: PlacementRequest, options?: any): AxiosPromise<PlacementResponseWrapper> {
            return localVarFp.createPlacement(placementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the minimum required bid in cents for a placement, based on the desired billing type and target categories. 
         * @summary Calculate minimum required bid for a placement
         * @param {string} placementId ID of the Placement
         * @param {PlacementMinBidRequest} placementMinBidRequest Request body for retrieving the minimum required bid for a placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinBid(placementId: string, placementMinBidRequest: PlacementMinBidRequest, options?: any): AxiosPromise<PlacementMinBidResponseWrapper> {
            return localVarFp.getMinBid(placementId, placementMinBidRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a placement.
         * @summary Get placement
         * @param {string} placementId ID of the Placement to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacement(placementId: string, options?: any): AxiosPromise<PlacementResponseWrapper> {
            return localVarFp.getPlacement(placementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns keyword suggestions for the placement for provided products based on searches of last 30 days and with AI matching. 
         * @summary Get product keyword suggestions
         * @param {string} placementId ID of the Placement to add a keyword
         * @param {PlacementKeywordSuggestionRequest} placementKeywordSuggestionRequest Request body for retrieving keyword suggestions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementKeywordSuggestions(placementId: string, placementKeywordSuggestionRequest: PlacementKeywordSuggestionRequest, options?: any): AxiosPromise<PlacementKeywordSuggestionResponseWrapper> {
            return localVarFp.getPlacementKeywordSuggestions(placementId, placementKeywordSuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns distinct keywords associated with that placement, which have been used in the past 4 weeks at least 5 times to request ads in the Ad Service. The keywords are sorted by request frequency in descending order.
         * @summary List placement keywords
         * @param {string} placementId ID of the Placement to retrieve
         * @param {string} [q] The query for a search in the placements\&#39;s keywords. When using &#x60;q&#x60;, no other query parameters will be considered.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlacementKeywords(placementId: string, q?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<PlacementKeywordsResponseWrapper> {
            return localVarFp.getPlacementKeywords(placementId, q, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of Placements available to the user.
         * @summary List placements
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;.   Available fields: - &#x60;id&#x60;: Placement ID, - &#x60;name&#x60;: Placement name, - &#x60;group&#x60;: Placement group, - &#x60;allowed_advertiser_ids&#x60;: Placement allowed advertiser IDs, and - &#x60;status&#x60;: Placement status. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlacements(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<PlacementsResponseWrapper> {
            return localVarFp.listPlacements(filter, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific field(s) of a Placement.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of Placement to partially update
         * @param {PlacementPatchUpdate} placementPatchUpdate Request body for partially updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUpdatePlacement(placementId: string, placementPatchUpdate: PlacementPatchUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.patchUpdatePlacement(placementId, placementPatchUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update details of a specific Placement. Complete object must be provided.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
         * @summary Update a placement
         * @param {string} placementId ID of the Placement to update
         * @param {PlacementUpdate} placementUpdate Request body for updating an existing placement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlacement(placementId: string, placementUpdate: PlacementUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updatePlacement(placementId, placementUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlacementsApi - object-oriented interface
 * @export
 * @class PlacementsApi
 * @extends {BaseAPI}
 */
export class PlacementsApi extends BaseAPI {
    /**
     * Archive a Placement. Placements are never permanently deleted.
     * @summary Archive placement
     * @param {string} placementId ID of the Placement to archive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public archivePlacement(placementId: string, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).archivePlacement(placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a placement. 
     * @summary Create a placement
     * @param {PlacementRequest} placementRequest Request body for creating a new placement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public createPlacement(placementRequest: PlacementRequest, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).createPlacement(placementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the minimum required bid in cents for a placement, based on the desired billing type and target categories. 
     * @summary Calculate minimum required bid for a placement
     * @param {string} placementId ID of the Placement
     * @param {PlacementMinBidRequest} placementMinBidRequest Request body for retrieving the minimum required bid for a placement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public getMinBid(placementId: string, placementMinBidRequest: PlacementMinBidRequest, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).getMinBid(placementId, placementMinBidRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a placement.
     * @summary Get placement
     * @param {string} placementId ID of the Placement to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public getPlacement(placementId: string, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).getPlacement(placementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns keyword suggestions for the placement for provided products based on searches of last 30 days and with AI matching. 
     * @summary Get product keyword suggestions
     * @param {string} placementId ID of the Placement to add a keyword
     * @param {PlacementKeywordSuggestionRequest} placementKeywordSuggestionRequest Request body for retrieving keyword suggestions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public getPlacementKeywordSuggestions(placementId: string, placementKeywordSuggestionRequest: PlacementKeywordSuggestionRequest, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).getPlacementKeywordSuggestions(placementId, placementKeywordSuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns distinct keywords associated with that placement, which have been used in the past 4 weeks at least 5 times to request ads in the Ad Service. The keywords are sorted by request frequency in descending order.
     * @summary List placement keywords
     * @param {string} placementId ID of the Placement to retrieve
     * @param {string} [q] The query for a search in the placements\&#39;s keywords. When using &#x60;q&#x60;, no other query parameters will be considered.
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public getPlacementKeywords(placementId: string, q?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).getPlacementKeywords(placementId, q, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of Placements available to the user.
     * @summary List placements
     * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;.   Available fields: - &#x60;id&#x60;: Placement ID, - &#x60;name&#x60;: Placement name, - &#x60;group&#x60;: Placement group, - &#x60;allowed_advertiser_ids&#x60;: Placement allowed advertiser IDs, and - &#x60;status&#x60;: Placement status. 
     * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
     * @param {number} [limit] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public listPlacements(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).listPlacements(filter, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific field(s) of a Placement.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
     * @summary Update a placement
     * @param {string} placementId ID of Placement to partially update
     * @param {PlacementPatchUpdate} placementPatchUpdate Request body for partially updating an existing placement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public patchUpdatePlacement(placementId: string, placementPatchUpdate: PlacementPatchUpdate, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).patchUpdatePlacement(placementId, placementPatchUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update details of a specific Placement. Complete object must be provided.  **Important**: Changes to the `category_targeting_mode` can only be performed by the Account Management team. API users **cannot** modify this field directly via PATCH or PUT requests. 
     * @summary Update a placement
     * @param {string} placementId ID of the Placement to update
     * @param {PlacementUpdate} placementUpdate Request body for updating an existing placement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacementsApi
     */
    public updatePlacement(placementId: string, placementUpdate: PlacementUpdate, options?: AxiosRequestConfig) {
        return PlacementsApiFp(this.configuration).updatePlacement(placementId, placementUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenanciesApi - axios parameter creator
 * @export
 */
export const TenanciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive a tenancy. Tenancies are never permanently deleted.
         * @summary Archive tenancy
         * @param {string} tenancyId ID of the tenancy to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenancy: async (tenancyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyId' is not null or undefined
            assertParamExists('archiveTenancy', 'tenancyId', tenancyId)
            const localVarPath = `/tenancies/{tenancy_id}`
                .replace(`{${"tenancy_id"}}`, encodeURIComponent(String(tenancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a tenancy, representing a fixed slot for a placement with a guaranteed position, fixed price, and time interval. Manual billing is required via the tenancy/bill endpoint upon expiration. Note: Product availability filter is not applied; out-of-stock products may still be served. 
         * @summary Create a tenancy
         * @param {TenancyRequest} tenancyRequest Request body for creating a new tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancy: async (tenancyRequest: TenancyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyRequest' is not null or undefined
            assertParamExists('createTenancy', 'tenancyRequest', tenancyRequest)
            const localVarPath = `/tenancies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a tenancy.
         * @summary Get tenancy
         * @param {string} tenancyId ID of the tenancy to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancy: async (tenancyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyId' is not null or undefined
            assertParamExists('getTenancy', 'tenancyId', tenancyId)
            const localVarPath = `/tenancies/{tenancy_id}`
                .replace(`{${"tenancy_id"}}`, encodeURIComponent(String(tenancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:tenancy", "read:tenancy"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all Tenancies available based on specified criteria.
         * @summary List tenancies
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy ID, - &#x60;name&#x60;: Tenancy name, - &#x60;placement_id&#x60;: Tenancy placement ID, - &#x60;position&#x60;: Tenancy position, - &#x60;status&#x60;: Tenancy status, - &#x60;start&#x60;: Tenancy start date, and - &#x60;end&#x60;: Tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenancies: async (filter?: string, orderBy?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tenancies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:tenancy", "read:tenancy"], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update particular field(s) of a specific tenancy.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to partially update.
         * @param {TenancyPatch} tenancyPatch Request body for partially updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenancy: async (tenancyId: string, tenancyPatch: TenancyPatch, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyId' is not null or undefined
            assertParamExists('patchTenancy', 'tenancyId', tenancyId)
            // verify required parameter 'tenancyPatch' is not null or undefined
            assertParamExists('patchTenancy', 'tenancyPatch', tenancyPatch)
            const localVarPath = `/tenancies/{tenancy_id}`
                .replace(`{${"tenancy_id"}}`, encodeURIComponent(String(tenancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific tenancy with a complete object.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to update.
         * @param {TenancyUpdate} tenancyUpdate Request body for updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancy: async (tenancyId: string, tenancyUpdate: TenancyUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyId' is not null or undefined
            assertParamExists('updateTenancy', 'tenancyId', tenancyId)
            // verify required parameter 'tenancyUpdate' is not null or undefined
            assertParamExists('updateTenancy', 'tenancyUpdate', tenancyUpdate)
            const localVarPath = `/tenancies/{tenancy_id}`
                .replace(`{${"tenancy_id"}}`, encodeURIComponent(String(tenancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenanciesApi - functional programming interface
 * @export
 */
export const TenanciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenanciesApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive a tenancy. Tenancies are never permanently deleted.
         * @summary Archive tenancy
         * @param {string} tenancyId ID of the tenancy to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTenancy(tenancyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTenancy(tenancyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a tenancy, representing a fixed slot for a placement with a guaranteed position, fixed price, and time interval. Manual billing is required via the tenancy/bill endpoint upon expiration. Note: Product availability filter is not applied; out-of-stock products may still be served. 
         * @summary Create a tenancy
         * @param {TenancyRequest} tenancyRequest Request body for creating a new tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTenancy(tenancyRequest: TenancyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTenancy(tenancyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a tenancy.
         * @summary Get tenancy
         * @param {string} tenancyId ID of the tenancy to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenancy(tenancyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenancy(tenancyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all Tenancies available based on specified criteria.
         * @summary List tenancies
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy ID, - &#x60;name&#x60;: Tenancy name, - &#x60;placement_id&#x60;: Tenancy placement ID, - &#x60;position&#x60;: Tenancy position, - &#x60;status&#x60;: Tenancy status, - &#x60;start&#x60;: Tenancy start date, and - &#x60;end&#x60;: Tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTenancies(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenanciesResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTenancies(filter, orderBy, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update particular field(s) of a specific tenancy.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to partially update.
         * @param {TenancyPatch} tenancyPatch Request body for partially updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTenancy(tenancyId: string, tenancyPatch: TenancyPatch, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTenancy(tenancyId, tenancyPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific tenancy with a complete object.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to update.
         * @param {TenancyUpdate} tenancyUpdate Request body for updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenancy(tenancyId: string, tenancyUpdate: TenancyUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenancy(tenancyId, tenancyUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenanciesApi - factory interface
 * @export
 */
export const TenanciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenanciesApiFp(configuration)
    return {
        /**
         * Archive a tenancy. Tenancies are never permanently deleted.
         * @summary Archive tenancy
         * @param {string} tenancyId ID of the tenancy to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenancy(tenancyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.archiveTenancy(tenancyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a tenancy, representing a fixed slot for a placement with a guaranteed position, fixed price, and time interval. Manual billing is required via the tenancy/bill endpoint upon expiration. Note: Product availability filter is not applied; out-of-stock products may still be served. 
         * @summary Create a tenancy
         * @param {TenancyRequest} tenancyRequest Request body for creating a new tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancy(tenancyRequest: TenancyRequest, options?: any): AxiosPromise<TenancyResponseWrapper> {
            return localVarFp.createTenancy(tenancyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a tenancy.
         * @summary Get tenancy
         * @param {string} tenancyId ID of the tenancy to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancy(tenancyId: string, options?: any): AxiosPromise<TenancyResponseWrapper> {
            return localVarFp.getTenancy(tenancyId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all Tenancies available based on specified criteria.
         * @summary List tenancies
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy ID, - &#x60;name&#x60;: Tenancy name, - &#x60;placement_id&#x60;: Tenancy placement ID, - &#x60;position&#x60;: Tenancy position, - &#x60;status&#x60;: Tenancy status, - &#x60;start&#x60;: Tenancy start date, and - &#x60;end&#x60;: Tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenancies(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<TenanciesResponseWrapper> {
            return localVarFp.listTenancies(filter, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update particular field(s) of a specific tenancy.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to partially update.
         * @param {TenancyPatch} tenancyPatch Request body for partially updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenancy(tenancyId: string, tenancyPatch: TenancyPatch, options?: any): AxiosPromise<void> {
            return localVarFp.patchTenancy(tenancyId, tenancyPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific tenancy with a complete object.
         * @summary Update tenancy
         * @param {string} tenancyId ID of the tenancy to update.
         * @param {TenancyUpdate} tenancyUpdate Request body for updating an existing tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancy(tenancyId: string, tenancyUpdate: TenancyUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTenancy(tenancyId, tenancyUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenanciesApi - object-oriented interface
 * @export
 * @class TenanciesApi
 * @extends {BaseAPI}
 */
export class TenanciesApi extends BaseAPI {
    /**
     * Archive a tenancy. Tenancies are never permanently deleted.
     * @summary Archive tenancy
     * @param {string} tenancyId ID of the tenancy to archive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public archiveTenancy(tenancyId: string, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).archiveTenancy(tenancyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a tenancy, representing a fixed slot for a placement with a guaranteed position, fixed price, and time interval. Manual billing is required via the tenancy/bill endpoint upon expiration. Note: Product availability filter is not applied; out-of-stock products may still be served. 
     * @summary Create a tenancy
     * @param {TenancyRequest} tenancyRequest Request body for creating a new tenancy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public createTenancy(tenancyRequest: TenancyRequest, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).createTenancy(tenancyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a tenancy.
     * @summary Get tenancy
     * @param {string} tenancyId ID of the tenancy to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public getTenancy(tenancyId: string, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).getTenancy(tenancyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all Tenancies available based on specified criteria.
     * @summary List tenancies
     * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy ID, - &#x60;name&#x60;: Tenancy name, - &#x60;placement_id&#x60;: Tenancy placement ID, - &#x60;position&#x60;: Tenancy position, - &#x60;status&#x60;: Tenancy status, - &#x60;start&#x60;: Tenancy start date, and - &#x60;end&#x60;: Tenancy end date. 
     * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
     * @param {number} [limit] The maximum number of items to return in the response.
     * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public listTenancies(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).listTenancies(filter, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update particular field(s) of a specific tenancy.
     * @summary Update tenancy
     * @param {string} tenancyId ID of the tenancy to partially update.
     * @param {TenancyPatch} tenancyPatch Request body for partially updating an existing tenancy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public patchTenancy(tenancyId: string, tenancyPatch: TenancyPatch, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).patchTenancy(tenancyId, tenancyPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific tenancy with a complete object.
     * @summary Update tenancy
     * @param {string} tenancyId ID of the tenancy to update.
     * @param {TenancyUpdate} tenancyUpdate Request body for updating an existing tenancy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenanciesApi
     */
    public updateTenancy(tenancyId: string, tenancyUpdate: TenancyUpdate, options?: AxiosRequestConfig) {
        return TenanciesApiFp(this.configuration).updateTenancy(tenancyId, tenancyUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenancyFiltersApi - axios parameter creator
 * @export
 */
export const TenancyFiltersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upsert tenancy filters to enable the use of different campaigns in the same tenancy. Use category_key in the ad request to determine the appropriate campaign for the tenancy slot. 
         * @summary Bulk upsert tenancy filters
         * @param {TenancyFiltersRequest} tenancyFiltersRequest Request body for bulk importing tenancy filters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenancyFilters: async (tenancyFiltersRequest: TenancyFiltersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFiltersRequest' is not null or undefined
            assertParamExists('addTenancyFilters', 'tenancyFiltersRequest', tenancyFiltersRequest)
            const localVarPath = `/tenancy-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyFiltersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a tenancy filter. Tenancy filters are never permanently deleted.
         * @summary Archive tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenancyFilter: async (tenancyFilterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFilterId' is not null or undefined
            assertParamExists('archiveTenancyFilter', 'tenancyFilterId', tenancyFilterId)
            const localVarPath = `/tenancy-filters/{tenancy_filter_id}`
                .replace(`{${"tenancy_filter_id"}}`, encodeURIComponent(String(tenancyFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bill a tenancy filter campaign.
         * @summary Bill tenancy filter campaign
         * @param {string} tenancyFilterId ID of tenancy filter to bill
         * @param {BillRequest} billRequest Request body for billing a tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billTenancyFilter: async (tenancyFilterId: string, billRequest: BillRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFilterId' is not null or undefined
            assertParamExists('billTenancyFilter', 'tenancyFilterId', tenancyFilterId)
            // verify required parameter 'billRequest' is not null or undefined
            assertParamExists('billTenancyFilter', 'billRequest', billRequest)
            const localVarPath = `/tenancy-filters/{tenancy_filter_id}/bill`
                .replace(`{${"tenancy_filter_id"}}`, encodeURIComponent(String(tenancyFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(billRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a tenancy filter.
         * @summary Get tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyFilter: async (tenancyFilterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFilterId' is not null or undefined
            assertParamExists('getTenancyFilter', 'tenancyFilterId', tenancyFilterId)
            const localVarPath = `/tenancy-filters/{tenancy_filter_id}`
                .replace(`{${"tenancy_filter_id"}}`, encodeURIComponent(String(tenancyFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:tenancy", "read:tenancy"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all Tenancy Filters available based on specified criteria.
         * @summary List tenancy filters
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy Filter ID, - &#x60;tenancy_id&#x60;: Tenancy Filter tenancy ID, - &#x60;line_item_id&#x60;: Tenancy Filter line item ID, - &#x60;categories&#x60;: Tenancy Filter categories, - &#x60;status&#x60;: Tenancy Filter status, - &#x60;tenancy.placement_id&#x60;: Tenancy Filter tenancy placement ID, - &#x60;tenancy.start&#x60;: Tenancy Filter tenancy start date, and - &#x60;tenancy.end&#x60;: Tenancy Filter tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenancyFilters: async (filter?: string, orderBy?: string, limit?: number, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tenancy-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["read-all:tenancy", "read:tenancy"], configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update particular field(s) of a specific tenancy filter.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to partially update.
         * @param {TenancyFilterPatch} tenancyFilterPatch Request body for partially updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenancyFilter: async (tenancyFilterId: string, tenancyFilterPatch: TenancyFilterPatch, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFilterId' is not null or undefined
            assertParamExists('patchTenancyFilter', 'tenancyFilterId', tenancyFilterId)
            // verify required parameter 'tenancyFilterPatch' is not null or undefined
            assertParamExists('patchTenancyFilter', 'tenancyFilterPatch', tenancyFilterPatch)
            const localVarPath = `/tenancy-filters/{tenancy_filter_id}`
                .replace(`{${"tenancy_filter_id"}}`, encodeURIComponent(String(tenancyFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyFilterPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific tenancy filter with a complete object.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to update.
         * @param {TenancyFilterUpdate} tenancyFilterUpdate Request body for updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancyFilter: async (tenancyFilterId: string, tenancyFilterUpdate: TenancyFilterUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyFilterId' is not null or undefined
            assertParamExists('updateTenancyFilter', 'tenancyFilterId', tenancyFilterId)
            // verify required parameter 'tenancyFilterUpdate' is not null or undefined
            assertParamExists('updateTenancyFilter', 'tenancyFilterUpdate', tenancyFilterUpdate)
            const localVarPath = `/tenancy-filters/{tenancy_filter_id}`
                .replace(`{${"tenancy_filter_id"}}`, encodeURIComponent(String(tenancyFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bearerAuth", ["write-all:tenancy"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenancyFilterUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyFiltersApi - functional programming interface
 * @export
 */
export const TenancyFiltersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenancyFiltersApiAxiosParamCreator(configuration)
    return {
        /**
         * Upsert tenancy filters to enable the use of different campaigns in the same tenancy. Use category_key in the ad request to determine the appropriate campaign for the tenancy slot. 
         * @summary Bulk upsert tenancy filters
         * @param {TenancyFiltersRequest} tenancyFiltersRequest Request body for bulk importing tenancy filters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTenancyFilters(tenancyFiltersRequest: TenancyFiltersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTenancyFilters(tenancyFiltersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Archive a tenancy filter. Tenancy filters are never permanently deleted.
         * @summary Archive tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveTenancyFilter(tenancyFilterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveTenancyFilter(tenancyFilterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Bill a tenancy filter campaign.
         * @summary Bill tenancy filter campaign
         * @param {string} tenancyFilterId ID of tenancy filter to bill
         * @param {BillRequest} billRequest Request body for billing a tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billTenancyFilter(tenancyFilterId: string, billRequest: BillRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billTenancyFilter(tenancyFilterId, billRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a tenancy filter.
         * @summary Get tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenancyFilter(tenancyFilterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyFilterResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenancyFilter(tenancyFilterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all Tenancy Filters available based on specified criteria.
         * @summary List tenancy filters
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy Filter ID, - &#x60;tenancy_id&#x60;: Tenancy Filter tenancy ID, - &#x60;line_item_id&#x60;: Tenancy Filter line item ID, - &#x60;categories&#x60;: Tenancy Filter categories, - &#x60;status&#x60;: Tenancy Filter status, - &#x60;tenancy.placement_id&#x60;: Tenancy Filter tenancy placement ID, - &#x60;tenancy.start&#x60;: Tenancy Filter tenancy start date, and - &#x60;tenancy.end&#x60;: Tenancy Filter tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTenancyFilters(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyFiltersResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTenancyFilters(filter, orderBy, limit, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update particular field(s) of a specific tenancy filter.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to partially update.
         * @param {TenancyFilterPatch} tenancyFilterPatch Request body for partially updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTenancyFilter(tenancyFilterId: string, tenancyFilterPatch: TenancyFilterPatch, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTenancyFilter(tenancyFilterId, tenancyFilterPatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific tenancy filter with a complete object.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to update.
         * @param {TenancyFilterUpdate} tenancyFilterUpdate Request body for updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenancyFilter(tenancyFilterId: string, tenancyFilterUpdate: TenancyFilterUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenancyFilter(tenancyFilterId, tenancyFilterUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenancyFiltersApi - factory interface
 * @export
 */
export const TenancyFiltersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenancyFiltersApiFp(configuration)
    return {
        /**
         * Upsert tenancy filters to enable the use of different campaigns in the same tenancy. Use category_key in the ad request to determine the appropriate campaign for the tenancy slot. 
         * @summary Bulk upsert tenancy filters
         * @param {TenancyFiltersRequest} tenancyFiltersRequest Request body for bulk importing tenancy filters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenancyFilters(tenancyFiltersRequest: TenancyFiltersRequest, options?: any): AxiosPromise<void> {
            return localVarFp.addTenancyFilters(tenancyFiltersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a tenancy filter. Tenancy filters are never permanently deleted.
         * @summary Archive tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to archive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveTenancyFilter(tenancyFilterId: string, options?: any): AxiosPromise<void> {
            return localVarFp.archiveTenancyFilter(tenancyFilterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bill a tenancy filter campaign.
         * @summary Bill tenancy filter campaign
         * @param {string} tenancyFilterId ID of tenancy filter to bill
         * @param {BillRequest} billRequest Request body for billing a tenancy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billTenancyFilter(tenancyFilterId: string, billRequest: BillRequest, options?: any): AxiosPromise<void> {
            return localVarFp.billTenancyFilter(tenancyFilterId, billRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a tenancy filter.
         * @summary Get tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyFilter(tenancyFilterId: string, options?: any): AxiosPromise<TenancyFilterResponseWrapper> {
            return localVarFp.getTenancyFilter(tenancyFilterId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all Tenancy Filters available based on specified criteria.
         * @summary List tenancy filters
         * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy Filter ID, - &#x60;tenancy_id&#x60;: Tenancy Filter tenancy ID, - &#x60;line_item_id&#x60;: Tenancy Filter line item ID, - &#x60;categories&#x60;: Tenancy Filter categories, - &#x60;status&#x60;: Tenancy Filter status, - &#x60;tenancy.placement_id&#x60;: Tenancy Filter tenancy placement ID, - &#x60;tenancy.start&#x60;: Tenancy Filter tenancy start date, and - &#x60;tenancy.end&#x60;: Tenancy Filter tenancy end date. 
         * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
         * @param {number} [limit] The maximum number of items to return in the response.
         * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTenancyFilters(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: any): AxiosPromise<TenancyFiltersResponseWrapper> {
            return localVarFp.listTenancyFilters(filter, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update particular field(s) of a specific tenancy filter.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to partially update.
         * @param {TenancyFilterPatch} tenancyFilterPatch Request body for partially updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenancyFilter(tenancyFilterId: string, tenancyFilterPatch: TenancyFilterPatch, options?: any): AxiosPromise<void> {
            return localVarFp.patchTenancyFilter(tenancyFilterId, tenancyFilterPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific tenancy filter with a complete object.
         * @summary Update tenancy filter
         * @param {string} tenancyFilterId ID of the tenancy filter to update.
         * @param {TenancyFilterUpdate} tenancyFilterUpdate Request body for updating an existing tenancy filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenancyFilter(tenancyFilterId: string, tenancyFilterUpdate: TenancyFilterUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTenancyFilter(tenancyFilterId, tenancyFilterUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenancyFiltersApi - object-oriented interface
 * @export
 * @class TenancyFiltersApi
 * @extends {BaseAPI}
 */
export class TenancyFiltersApi extends BaseAPI {
    /**
     * Upsert tenancy filters to enable the use of different campaigns in the same tenancy. Use category_key in the ad request to determine the appropriate campaign for the tenancy slot. 
     * @summary Bulk upsert tenancy filters
     * @param {TenancyFiltersRequest} tenancyFiltersRequest Request body for bulk importing tenancy filters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public addTenancyFilters(tenancyFiltersRequest: TenancyFiltersRequest, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).addTenancyFilters(tenancyFiltersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a tenancy filter. Tenancy filters are never permanently deleted.
     * @summary Archive tenancy filter
     * @param {string} tenancyFilterId ID of the tenancy filter to archive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public archiveTenancyFilter(tenancyFilterId: string, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).archiveTenancyFilter(tenancyFilterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bill a tenancy filter campaign.
     * @summary Bill tenancy filter campaign
     * @param {string} tenancyFilterId ID of tenancy filter to bill
     * @param {BillRequest} billRequest Request body for billing a tenancy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public billTenancyFilter(tenancyFilterId: string, billRequest: BillRequest, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).billTenancyFilter(tenancyFilterId, billRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a tenancy filter.
     * @summary Get tenancy filter
     * @param {string} tenancyFilterId ID of the tenancy filter to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public getTenancyFilter(tenancyFilterId: string, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).getTenancyFilter(tenancyFilterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all Tenancy Filters available based on specified criteria.
     * @summary List tenancy filters
     * @param {string} [filter] Filter the result. See filtering query basics at [Filtering concept](https://docs.retailmediatools.com/reference/filtering). Due to implementation limitations, only the following operators are supported: &#x60;&#x3D;&#x60;, &#x60;&gt;&#x60;, &#x60;&lt;&#x60;, &#x60;&gt;&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60;, &#x60;AND&#x60;. Use &#x60;OR&#x60; to filter by multi-choice fields, such as &#x60;status&#x60;tenancy.id  Available fields: - &#x60;id&#x60;: Tenancy Filter ID, - &#x60;tenancy_id&#x60;: Tenancy Filter tenancy ID, - &#x60;line_item_id&#x60;: Tenancy Filter line item ID, - &#x60;categories&#x60;: Tenancy Filter categories, - &#x60;status&#x60;: Tenancy Filter status, - &#x60;tenancy.placement_id&#x60;: Tenancy Filter tenancy placement ID, - &#x60;tenancy.start&#x60;: Tenancy Filter tenancy start date, and - &#x60;tenancy.end&#x60;: Tenancy Filter tenancy end date. 
     * @param {string} [orderBy] Specifies the sorting order. The default sorting order is descending. To specify ascending order for a field, append a &#x60;asc&#x60; suffix; for example: &#x60;created_at asc&#x60;. Redundant space characters in the syntax are insignificant. &#x60;foo, bar asc&#x60;, &#x60; foo , bar asc &#x60;, and &#x60;foo,bar asc&#x60; are all equivalent.
     * @param {number} [limit] The maximum number of items to return in the response.
     * @param {string} [cursor] Token for pagination, indicating the starting point for fetching results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public listTenancyFilters(filter?: string, orderBy?: string, limit?: number, cursor?: string, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).listTenancyFilters(filter, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update particular field(s) of a specific tenancy filter.
     * @summary Update tenancy filter
     * @param {string} tenancyFilterId ID of the tenancy filter to partially update.
     * @param {TenancyFilterPatch} tenancyFilterPatch Request body for partially updating an existing tenancy filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public patchTenancyFilter(tenancyFilterId: string, tenancyFilterPatch: TenancyFilterPatch, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).patchTenancyFilter(tenancyFilterId, tenancyFilterPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific tenancy filter with a complete object.
     * @summary Update tenancy filter
     * @param {string} tenancyFilterId ID of the tenancy filter to update.
     * @param {TenancyFilterUpdate} tenancyFilterUpdate Request body for updating an existing tenancy filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyFiltersApi
     */
    public updateTenancyFilter(tenancyFilterId: string, tenancyFilterUpdate: TenancyFilterUpdate, options?: AxiosRequestConfig) {
        return TenancyFiltersApiFp(this.configuration).updateTenancyFilter(tenancyFilterId, tenancyFilterUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


